import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint sonarjs/no-duplicate-string: 0 */


import { extendTheme } from "native-base";
import baseTheme from "./base.theme";
import Platform from "react-native-web/dist/cjs/exports/Platform"; // Define the config

var config = {
  colors: {
    primary: {
      100: "#A1784D",
      200: "#7C5D3C",
      300: "#DF4505",
      // TODO: replace this placeholder with appropriate color (this is for the focusring and hover to work)
      400: "#A1784D",
      500: "#A1784D",
      600: "#A1784D"
    },
    secondary: {
      100: "#B34B00",
      200: "#AF272F",
      300: "#A1784D"
    },
    background: {
      100: "#F9F8F1",
      200: "#EBE9E9",
      300: "#DAD4D5",
      400: "#F2EFEA"
    },
    indicatorBannerColors: {
      indicatorBannerColor_NI: "#00B0B9",
      indicatorBannerColor_LT: "#a8b341",
      indicatorBannerColor_CSK_B: "#b3292d",
      indicatorBannerColor_Default: "#C6653B"
    },
    viewMenuHover: "#A1784D",
    outletLocationRestText: "#A1784D",
    orderOnlineHomeButton: "#A1784D",
    errorModalHeaderBg: "#F9F8F1",
    circularAddBtn: "#A1784D",
    locationListBtn: "#A1784D",
    startBgColor: "#EDE3C7",
    secondary200Mobile: "#A1784D",
    confirmationModalOptionBg: "#F2EFEA",
    asapOptionBg: "#F9F8F1",
    asapTextColor: "#404040",
    menuItemCardBg: "#F9F8F1",
    menuItemCardBorder: "transparent",
    selectedMenuCategoryBorder: "#A1784D",
    themeErrorColor: "#F5D6D8",
    bannerDropShadow: "#5F2C2D",
    mobilePayNotYourCheckTextColor: "#606060",
    mobilePayReachOutSubTextColor: "#782434",
    themeErrorTextColor: "#CD3838",
    themeTextFieldBoundary: "#DEDEDE",
    themeSectionSeparator: "#D6D6D6",
    listItemDivider: "#D6D6D6",
    cartNumberText: "#ffff",
    categoryBoxDivider: "#D6D6D6",
    firstCategoryBoxDivider: "#D6D6D6",
    categoryBoxTop: "#D6D6D6",
    categoryBoxBottom: "#D6D6D6",
    hStackArrowsBg: "#F9F8F1F9",
    themeSectionSeparatorDark: "#979797",
    orderInfoBg: "#ffff",
    specialInstInputBg: "#ffff",
    timeDropDownBg: "#FFFFFF",
    modalLightBg: "#FFFFFF",
    modalDarkBg: "#F8F8F8",
    themeSectionTextDark: "#8A8A8A",
    infoLinkColor: "#A2794D",
    backLinkColor: "#A2794D",
    themeTextColor: "#020001",
    legalDesclaimerText: "#020001",
    themeGrey: "#606060",
    headerBackground: "white",
    themeDarkGrey: "#2E2A26",
    downArrowColor: "#020001",
    mobileBg: "#FFFFFF",
    categoryNavBgColor: "#F9F8F1",
    globalBannerBg: "#131313",
    orderSettingsDateTimeChoiceColor: "#C16436",
    selectedOptionBorderColor: "#A2794D",
    menuDetailsMobileHeaderText: "#A2794D",
    configOptionsAccordionBackground: "#A2794D",
    hStackArrowsColor: "#7C5D3C",
    popoverBg: "#F2EFEA",
    separatorLineColor: "#A1784D",
    categoryHeaderSeparator: "#EAEAEA",
    specialInstArrowColor: "black",
    btnHoverColor: "#7C5D3C",
    menuListTooltipBg: "#303030",
    menuListTooltipColor: "#FFFFFF",
    menuDetailTooltipBg: "#3f3f46",
    menuDetailTooltipColor: "#d4d4d8",
    plusIconColor: "#A1784D",
    menuItemNameColor: "#020001",
    legalTextContainerBg: "#EFEFEF",
    menuLinksColor: "#606060",
    cartHeaderOrderType: "#332C28",
    cartHeaderLocationName: "#A1784D",
    menuItemAddButtonColor: "#A1784D",
    // Newly added token names from other brand theme (OG && LH)
    themeDisableButton: "#E5E5E5",
    orderConfirmationDivider: "#E5E5E5",
    deliveryModalHeadingColor: "#2A2C25",
    deliveryModalBrandColor: "#54301A",
    deliveryModalNameColor: "#A2402A",
    sliderItemColor: "#A1784D",
    refreshIconColor: "#A1784D",
    headerBackgroundTop: "white",
    // Menu Listing
    menuButtonBackgroundColor: "#A1784D",
    orderSettingsTextColor: "#A1784D",
    categoriesText: "#A1784D",
    configOptionBg: "white",
    modalCategoriesText: "#A1784D",
    inActiveCategoriesText: "#606060",
    inActiveModalCategoriesText: "#606060",
    menuItemPriceColor: "#21170D",
    reOrderAddBtnBorder: "#A1784D",
    menuItemCalorieColor: "#020001",
    scrollToTopColor: "#A1784D  ",
    itemAddToCartPopupBackground: "#A1784D",
    recommendationaInfoTextColor: "#020001",
    reorderInfoTextColor: "#332C28",
    emptyCartHeaderBgColor: "#F6F4F3",
    reorderHeadingsText: "#020001",
    // Menu Details
    notSelectedOptionBorderColor: "#D7D7D7",
    sliderWithButtonsBackground: "#FFFFFFE5",
    recommendationHeadingColor: "#020001",
    menuDetailAccordionDownArrowColor: "#A1784D",
    menuDetailAccordionTextColor: "#332C28",
    menuDetailsAccordionDetailsBackground: "#F7F7F7",
    menuDetailsAccordionDetailsBackgroundNotDefaultExpanded: "#FFFFFF",
    menuDetailModifyOrRemoveColor: "#020001",
    menuDetailTemparatureSliderLabelColor: "#303030",
    menuDetailItemNameColor: "#2A2C25",
    legalDisclaimerText: "#020001",
    menuDetailsItemPriceColor: "#020001",
    menuDetailsItemDescriptionColor: "#A1784D",
    menuDetailsItemCaloriesCaolor: "#020001",
    menuDetailsModifiersBorderColor: "#A2794D ",
    menuDetailsBackToMenu: "#A2794D",
    menuDetailsSliderItemBackground: "#EBE9E9",
    menuDetailsSliderHoverColor: "#A1784D",
    loginModalTextColor: "#737373",
    requiredTextColor: "#D93D3D",
    nutritionalHTMLColor: "#020001",
    // Menu Details END
    orderConfirmationTextColor: "#A1784D",
    locationListingItemText: "#020001",
    locationListingItemHeading: "#020001",
    locationListingItemHeadingMobile: "#A1784D",
    confirmPickupDetailsText: "#2D2926",
    addressTextColor: "#303030",
    tempSilderText: "#BA685C",
    selectTemperatureAccordian: "#E9E9E9",
    itemIsFor: "#606060",
    itemIsForName: "#332C28",
    cartItemTitle: "#332C28",
    cartPhoneNumber: "#A1784D",
    cartItemActionBtn: "#A1784D",
    cartItemPrice: "#A1784D",
    cartNoOfItemsText: "#B34B00",
    specialInstructions: "#332C28",
    cartItemOption: "#030000",
    locationsNear: "black",
    searchResultsName: "#303030",
    locationConfirmationHeadings: "#C16436",
    orderSettingsDesktop: "#1E1C19",
    orderSettingsMobile: "#1E1C19",
    previousOrderItemStatus: "#A1784D",
    accordionDescription: "white",
    skuUnavaliableTextColor: "#A2402C",
    youMightLikeBannerColor: "#000000",
    defaultMenuBannerBg: "#2f2f2f",
    newIndicatorBannerColor: "#00B0B9",
    defaultMenuTextColor: "white",
    quantityArrowColor: "#A1784D",
    textCTAColor: "#A1784D",
    orderSettingsDivider: "#D6D6D6",
    orderSettingsDividerMobile: "#D6D6D6",
    orderSettingsBorder: "#D6D6D6",
    modalTextColor: "#020001",
    selectedListItem: "#F9F8F1",
    selectedCarouselItemWithoutImage: "#F6F4F3",
    unselectedCarouselItemWithoutImage: "#ffff",
    checkoutButtonBackgroundColor: "#A1784D",
    remoteCheckinWaitTimeBg: "#F9F8F1",
    remoteCheckinWaitTimeBorderTwo: "rgba(128, 96, 61, 0.1)",
    remoteCheckinWaitTimeBorderOne: "rgba(128, 96, 61, 0.2)",
    remoteCheckinWaitTimeInnerBorder: "rgba(128, 96, 61, 1)",
    remoteCheckinWaitTimeCircleBg: "#FFFFFF",
    remoteCheckinWaitTimeHeaderText: "rgba(128, 96, 61, 1)",
    remoteCheckinWaitTimeText: "rgba(128, 96, 61, 1)",
    remoteCheckinWaitTime: "rgba(96, 96, 96, 1)",
    remoteCheckinRefreshBtnColor: "#A1784D",
    remoteCheckinRefreshBtnBg: "#FFFFFF",
    remoteCheckinPartySizeText: "#4E311F",
    locationListItemBorder: "rgba(0,0,0,.1)",
    allLocationsSelectBgMobile: "#F9F8F1",
    allLocationsSelectBgDesktop: "#FFFFFF",
    locationCardBg: "#ffff",
    locationDropdownBg: "#ffff",
    allLocationsSelectBorderColorMobile: "#000000",
    allLocationsSelectBorderColorDesktop: "#D6D6D6",
    allLocationsItemBoxBorderColor: "#DEDEDE",
    allLocationsBodyBgMobile: "#E5E5E5",
    allLocationsBodyBgDesktop: "#F6F4F3",
    allLocationsSelectBorderColor: "#DEDEDE",
    confirmPickupDetailsChangeBtnBorder: "#A1784D",
    ninjaIconColor: "#A1784D",
    checkoutBorderColor: "transparent",
    categoriesHeadingColor: "#020001",
    itemUnavailableCardBg: "#F9F8F1",
    itemCardBg: "#F9F8F1",
    itemCardBgLight: "#F9F8F1",
    // ORDER CONFIRMATION START
    orderConfirmationCustomerEmail: "#A1784D",
    orderConfirmationBackground: "#F6F6F6",
    confirmationPrimary: "#A1784D",
    confirmationSecondary: "#303030",
    confirmationAccent: "#2A2C25",
    confirmationAccentLight: "#666666",
    confirmationAccentDark: "#303030",
    confirmationCheckbox: "#A1784D",
    confirmationThemeDark: "#000000",
    confirmationThemeLight: "#EEEEEE",
    confirmationThemeGrey: "#B0B0B0",
    pickMyOrderCardTitle: "#A1784D",
    podBackground: "white",
    confirmationSpecialInstructionsBg: "#EEEEEE",
    // ORDER CONFIRMATION END
    // order tracking page
    orderStatusText: "#4D2C42",
    orderStatusCircleBg: "#000000",
    locaionAndTimeHeaderBg: "#F9F8F1",
    locaionAndTimeHeaderBorder: "#DCDCDC",
    borderColorCallSection: "#DCDCDC",
    payNowButtonBg: "#A1784D",
    curbsideCheckInPrimary: "#FFFFFF",
    curbsideCheckInSecondary: "#A1784D",
    orderStatusSectionBg: "#F4F4F4",
    refreshButtonColor: "#A1784D",
    checkText: "#303030",
    curbsideCheckInAvailable: "#7C7C7C",
    orderStatusSectionBorderColor: "#DCDCDC",
    refreshButtonBg: "#FFFFFF",
    // order tracking page end
    categoriesPopupInactive: "#606060",
    categoriesPopupBg: "white",
    bodyBg: "transparent",
    quickAddModalBg: "white",
    cardColor: "#F9F8F1",
    menuInfoBackgroundMobile: "#FFFFFF",
    menuInfoBackgroundDesktop: "#F9F8F1",
    selectedSKUItem: "#F9F8F1",
    nonSelectedSkuItem: "white",
    nonSelectedListItem: "white",
    selectedListItemWithImage: "white",
    nonExpandedAccordionBackground: "#F9F8F1",
    selectedDescriptionText: "#020001",
    carouselBorderColor: "transparent",
    signInTextColor: "#020001",
    registerTextColor: "#020001",
    recommendationsHeadingColor: "#020001",
    capacityInfoText: "#606060",
    selectedStateColor: "#000000",
    quantityColor: "#020001",
    timeDropdownColor: "#000000",
    searchKeywordHighlightColor: "#A1784D",
    waitlistBannerBg: "#A1784D",
    waitlistFooterBorderTop: "#B0B0B0",
    waitlistBottomBackground: "#F9F8F1",
    waitlistTableHeaderBg: "#F8F8F8",
    selectedWaitlistRow: "#F9F8F1",
    waitlistDisclaimer: "#303030",
    fwlvMiddleCtaBackground: "#ECE0D4",
    howItWorksBannerBg: "#A1784D",
    howItWorksHeaderBg: "#FAF3EE",
    //Menu search
    searchModalCategoryListBg: "#F6F6F6",
    searchIconContainerBgColor: "#DF4505",
    mobilePayUserLoginBackground: "#FFFFFF",
    mobilePayUserLoginButtonTextColor: "#FFFFFF",
    mobilePayBodyTextColor: "#606060",
    searchItemCardTextColor: "#505050",
    menuSearchBarContainerBg: "#FFFFFF",
    // original YH tokens
    profileHeaderBackground: "#A1784D",
    locationTopTabColor: "#A1784D",
    grey300: "#303030",
    reoderInfoTextColor: "#404040",
    onboardingButtonTextColor: "#FFFFFF",
    mobileAppAuthBg: "white",
    myReservationsBoxBg: "white",
    mobileAuthOrDividerBorderColor: "#CDCFD5",
    mobileAuthOrTextColor: "#737373",
    mobileAuthFooterPassiveText: "#808080",
    mobileAuthFooterActiveText: "#A1784D",
    mobileAuthTransparentBg: "rgba(0, 0, 0, 0.7)",
    mobileCriticalModeHeding: "#606060",
    mobileCriticalModeText: "#959595",
    mobileCreateAccountDetailsSectionBackgroundColor: "#FFFFFF",
    mobileCreateAccountButtonTextColor: "#FFFFFF",
    mobileCreateAccountLegalNoticesColor: "#cb7034",
    mobileCriticalModeBg: "#E5E5E5",
    mobileForgotPasswordHeding: "#606060",
    linearGradientTransparent: "rgba(255,255,255,0)",
    linearGradientWhite: " rgba(255,255,255,1)",
    linearGradientCardDarkShade: "rgba(54, 26, 5, 0.84)",
    linearGradientCardLightShade: "rgba(54, 26, 5, 0.44)",
    linearGradientCardTransparent: "rgba(35,34,30,0)",
    linearGradientHeaderDark: "#382007",
    linearGradientHeaderLight: "rgba(0,0,0,0)",
    ratingCardTitle: "#2A2C25",
    ratingCardSubheaderText: "#606060",
    ratingCardBodyHeader: "#606060",
    ratingCardTextAreaBorderColor: "F3F4EA",
    ratingCardTextAreaWordCount: "rgba(0, 0, 0, 0.4)",
    ratingCardSubmitButton: "#A2402A",
    ratingCardSubmitButtonText: "#FFFFFF",
    ratingCardDismissButtonText: "#808080",
    mobileForgotPasswordHeading: "#606060",
    mobileResetPasswordText: "#606060",
    mobileCustomBrandModalBg: "#F8F7F6",
    restaurantDetailsDataText: "#303030",
    mobileHeaderBg: "rgba(255, 255, 255, 0.9)",
    waitlistRestaurantInfoBoxText: "#4E311F",
    routerNavigationHeaderColor: "rgba(0, 0, 0, 0.7)",
    displayImageFallbackBackground: "#C6C6C6",
    mobileOrderDetailsBanner: "#F9F8F1",
    mobileOrderDetailsDisabledButton: "#C6C6C6",
    mobileOrderDetailsBg: "white",
    locationModalHeadingColor: "#2A2C25",
    locationModalBodyDataColor: "#808080",
    locationModalDividerColor: "#C6C6C6",
    restaurantsTimingDetails: "#606060",
    restaurantLabelColor: "#606060",
    joinWaitlistColor: "#A1784D",
    disableJoinWaitlistColor: "#C6C6C6",
    wcacSecondaryBtnBorder: "#A1784D",
    mobileSelectedVehicleTypeBg: "#F4F4F4",
    mobileSliderSeparator: "#BEBEBE",
    locationInfographicModalTextColor: "#606060",
    locationInfographicModalActionButtonTextColor: "#FFFFFF",
    inputPlaceholderTextColor: "#303030",
    restaurantInfoNumberAndDistanceTextColor: "#A1784D",
    restaurantDetailsHeaderBackground: "#FFFFFF",
    amenitiesHeadingColor: "#020001",
    jwcOrderAheadImgOverlayShade: "rgba(0, 0, 0, 0.4)",
    amenitiesDividerColor: "rgba(0,0,0,0.2)",
    amenitiesActionButtonsColor: "#A1784D",
    currentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantWaitlistTextColor: "#606060",
    joinWaitlistButtonColor: "#A1784D",
    orderFromHereButtonTextColor: "#FFFFFF",
    restaurantAboutSectionHeadingTextColor: "#020001",
    restaurantAboutSectionBodyTextColor: "#303030",
    restaurantImageBorderColor: "#FFFFFF",
    restaurantNumberAndDistanceDividerColor: "rgba(0,0,0,0.20)",
    restaurantHoursTextColor: "#606060",
    restaurantSpecialDayHeadingTextColor: "#303030",
    restaurantSpecialDayBodyTextColor: "#606060",
    restaurantTimingsHeadingTextColor: "#54301A",
    restaurantTimingsDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsSeparatorDividerColor: "rgba(0,0,0,0.1)",
    restaurantTimingsTextColor: "#494949",
    locationTabNavigationNotFocusedTabText: "#606060",
    locationInfographicLoginBackgroundColor: "#FFFFFF",
    locationOverlayMyLocationsTitles: "#303030",
    locationOverlayMyLocationsScrollView: "#FFFFFF",
    locationOverlaySelectLocationColor: "#2A2C25",
    noRecentLocationsTextColor: "#606060",
    searchThisAreaText: "#FFFFFF",
    selectedWeekDayColor: "#A1784D",
    notSelectedWeekDayColor: "#FFFFFF",
    weekDayBorderColor: "#DCDCDC",
    currentWeekDayIndicator: "#A1784D",
    mobileScrollableMenuTab: "#F8F8F8",
    joinWaitlistBackgrouondColor: "#F6F6F6",
    joinWaitlistFormBgColor: "#FFFFFF",
    joinWaitlistFormBorder: "#D9D9D9",
    waitlistHeaderAddressHeaderBorder: "#D6D6D6",
    orderConfirmationThanksSubHeaderColor: "#505050",
    pickupRestaurantTitle: "#737373",
    pickupRestaurantName: "#303030",
    pickupRestaurantAddress: "#606060",
    pickUpMyOrderHStackText: "#303030",
    bottomSheetTitleColor: "#303030",
    errorModalBackgroundColor: "rgba(29, 26, 26, 0.88)",
    errorModalTitleColor: "#2A2C25",
    errorModalSubTitleTextColor: "#606060",
    errorModalOKButtonTextColor: "#FFFFFF",
    addCardModalValidWarningTextColor: "#D30000",
    cardExpiredColor: "#D51010",
    saveCardCheckbox: "#737373",
    saveCardAddButtonTextColor: "#FFFFFF",
    enterCVVSubTitle: "#606060",
    enterCVVPlaceholderText: "#606060",
    enterCVVTooltipBgColor: "#e3e3e3",
    enterCVVValidWarningTextColor: "#D30000",
    enterCVVConfirmButtonDisabledColor: "#C6C6C6",
    enterCVVConfirmButtonTextColor: "#FFFFFF",
    mobilePaymentMethodIconBg: "#F6F6F6",
    mobilePaymentsCardTextColor: "white",
    mobileGiftCardGradientFirst: "#A0774D",
    mobileGiftCardGradientSecond: "#423F3C",
    mobileMasterCardGradientFirst: "#2A0000",
    mobileMasterCardGradientSecond: "#912F2F",
    mobileMasterCardGradientThird: "#5A1F21",
    mobileVisaGradientFirst: "#026C6C",
    mobileVisaGradientSecond: "#12414B",
    mobileVisaGradientThird: "#015F5F",
    mobileDiscoverGradientFirst: "#95989F",
    mobileDiscoverGradientSecond: "#D1D5D8",
    mobileDiscoverGradientThird: "#93969B",
    mobileAmericanExpressGradientFirst: "#1B1B1D",
    mobileAmericanExpressGradientSecond: "#5E5E62",
    mobileAmericanExpressGradientThird: "#1E1E20",
    mobileJcbCardGradientFirst: "#001741",
    mobileJcbCardGradientSecond: "#195182",
    mobileJcbCardGradientThird: "#2B3E7F",
    mobilePaymentMethodAssistTextColor: "#808080",
    mobileCouponInputPlaceholderColor: "#C7C0C0",
    mobilePaymentsScreenBg: "white",
    addGiftCardBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    enterCVVBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    addCreditDebitCardTooltipBgColor: "#e3e3e3",
    yourOrderTitle: "#303030",
    orderDescriptionItem: "#2A2C25",
    orderTotalTitle: "#54301A",
    pickupDetailsTitle: "#303030",
    mobilePayHeaderBtnBorder: "#A1784D",
    carSideStackTitle: "#606060",
    cardCreateAnAccountHeading: "#303030",
    takeSurveyText: "#606060",
    joinEClubTitle: "#303030",
    joinEClubTickScheme: "#A8AD00",
    mobileGiftVoucherGiftText: "#E7A227",
    mobileGiftVoucherVoucherIDText: "#C6C6C6",
    mobileGiftVoucherValueFirstGrad: "#F6C551",
    mobileGiftVoucherValueSecondGrad: "#B15801",
    mobileGiftVoucherBoxFirstGrad: "#423F3F",
    mobileGiftVoucherBoxSecondGrad: "#5F5852",
    mobileGiftCardNormalText: "white",
    wailistHomeScreenBannerGradientOne: "#80603D",
    waitlistHomeScreenBannerGradientTwo: "#A1784D",
    waitlistHomeScreenBannerText: "#FFFFFF",
    waitlistBannerCircleOuterBorder: "rgba(255,255,255,0.2)",
    waitlistBannerFooterText: "#303030",
    waitlistPositionBackground: "#F3F4E7",
    jwcBgColor: "#EFEFEF",
    waitlistPositionBorderTwo: "rgba(128, 96, 61, 0.4)",
    waitlistPositionBorderOne: "rgba(128, 96, 61, 0.9)",
    waitlistPositionInnerBorder: "#80603D",
    waitlistPositionCircleBackgroundColor: "#FFFFFF",
    waitlistPositionSubTitle: "#606060",
    waitlistPositionButtonBackground: "#FFFFFF",
    waitlistPositionSubTextColor: "#303030",
    waitlistSubCardsVerticalDivider: "#F6F6F6",
    waitlistDetailsSwiperText: "#FFFFFF",
    checkbackSoonBgImgOverlayColor: "#F9F8F1",
    waitlistSwiperNavigationButtonBorderColor: "#FFFFFF",
    waitlistSwiperNavigationButtonBackgroundColor: "#FFFFFF",
    seasonFavouriteTitleText: "#FFFFFF",
    seasonFavouritesHeadingDivider: "#4D4D4D",
    waitlistMapSectionBorder: "#DCDCDC",
    waitlistMapSectionButtonBackground: "#FFFFFF",
    waitlistDetailsOrderbuttonText: "#FFFFFF",
    waitlistPositionHeadingText: "#2A2C25",
    waitlistDetailsScreenBackground: "#FFFFFF",
    waitlistBannerCircleBackgroundColor: "#FFFFFF",
    mobileCategoryNavigationBg: "#F8F8F8",
    mobileOrderSummaryBackground: "#F6F6F6",
    mobileOrderSummaryHeaderText: "#303030",
    mobileOrderSummaryDishQuantity: "#2A2C25",
    mobileOrderSummaryOtherInstructions: "#606060",
    mobileOrderSummaryOrderTotalDetailsItem: "#000000",
    mobileOrderSummaryOrderTotalDetailsItemCoupon: "#CA7C30",
    mobileOrderSummaryPaidByColor: "#303030",
    myAccountSubTextColor: "#606060",
    myAccountScreenBackroundColor: "#F6F6F6",
    myAccountScreenUserInfoTextColor: "#606060",
    myAccountCardShadow: "rgba(0, 0, 0, 0.2)",
    myAccountCardBackground: "#FFFFFF",
    ProfilePictureCircleBorderColor: "#FFFFFF",
    mobileOrderSettingsOptionStackBorderColor: "#DEDEDE",
    orderSettingsPickupDetails: "#2A2C25",
    orderSettingsBackdrop: "rgba(0, 0, 0, 0.7)",
    curbsideHomeScreenBannerGradientOne: "#80603D",
    curbsideHomeScreenBannerGradientTwo: "#A1784D",
    curbsideHomeScreenBannerText: "#523020",
    curbsideDetailsBackground: "#F3F4E7",
    curbsidePickupScreenBackground: "#FFFFFF",
    curbsidePickupScreenDetailsBackground: "#F2F4E6",
    curbsidePickupScreenDetailsDivider: "#DCDCDC",
    curbsidePickupScreenBannerText: "#523020",
    curbsidePickupScreenDetailsSubText: "#303030",
    curbsidePickupScreenDetailsIconsBackground: "#F6F6F6",
    curbsidePickupScreenDetailsEditButtonText: "#993324",
    viewDirectionButtonTextColor: "#FFFFFF",
    restaurantLocationBottomSheetBackdropColor: "rgba(0,0,0,0.6)",
    modalHeaderBackgroundColor: "rgba(0, 0, 0, 0.7)",
    restuarantLocationBottomSheetLocationText: "#606060",
    addGiftCardHeaderTextColor: "#2A2C25",
    mobileOrderHistoryBackgroundColor: "#F6F6F6",
    mobileOrderHistoryItemCardHeaderBackgroundColor: "#FFF",
    orderHistoryItemDividerColor: "#C6C6C6",
    orderHistoryReorder: "#993324",
    orderHistoryDetailsText: "#303030",
    orderHistoryOrderFrom: "#808080",
    jwcLeaveTheLineModalHeadBg: "#D7D2CB",
    orderHistoryDetailsAddress: "#606060",
    orderHistoryDetailsBGColor: "#F6F6F6",
    searchBarBackground: "#FFFFFF",
    addCardFooterButtonText: "#FFFFFF",
    homeScreenBackgroundColor: "#F6F6F6",
    homeScreenOrderNowButtonTextColor: "#FFFFFF",
    homeScreenHeaderIconColors: "#FFFFFF",
    homeScreenLoginBorderColor: "#FFFFFF",
    homeScreenCardButtonTextColor: "#FFFFFF",
    homeScreenCardButtonBorderColor: "#FFFFFF",
    homeScreenCardTextColor: "#FFFFFF",
    myAccountCartAmountTextBorderColor: "#FFFFFF",
    myAccountCartAmountTextColor: "#FFFFFF",
    selectPreferredLocationBackgroundColor: "#FFFFFF",
    outletLocationItemIconText: "#FFFFFF",
    outletLocationItemButtonText: "#FFFFFF",
    profileScreenMainModalBackgroundColor: "#FFFFFF",
    HomeScreenlinearGradientBackgroundColor: "#F6F6F6",
    homeScreenRecentOrdersListItemSubTextColor: "#606060",
    homeScreenRecentOrdersListItemDividerColor: "#C6C6C6",
    homeScreenRecentOrdersListItembackgroundColor: "#FFFFFF",
    homeScreenRecentOrdersListItemButtonTextColor: "#FFFFFF",
    addCardPlaceholderTextColor: "#606060",
    addCardCheckboxTextColor: "#606060",
    mobileReorderBg: "#F8F8F8",
    editProfileScreensBackgroundColor: "#FFFFFF",
    googleSocialSignInBGColor: "#FFFFFF",
    facebookSocialSignInBGColor: "#1877F2",
    appleSocialSignInBGColor: "#000000",
    socialAuthBorderColor: "#DEDEDE",
    createAccountPreferredLocationBGColor: "#F8F7F6",
    cartScreenBackgroundColor: "#FFFFFF",
    orderLimitReacherModalBackdrop: "rgba(0,0,0,0.7)",
    cartHeaderPressableColor: "#F6F6F6",
    securityQuestionContainer: "#ffffff",
    securityQuestionMenuColor: "#C6c6c6",
    securityQuestionTextColor: "#606060",
    createAccountBackgroundColor: "#FFFFFF",
    createAccountScreenTextColor: "#303030",
    createAccountZipCodeBorderColor: "#DCDCDC",
    createAccountZipCodeLabelColor: "#808080",
    settingScreenBg: "#F8F8F8",
    settingListItemShadow: "rgba(0,0,0,0.5)",
    frequentlyOrderedItemBackground: "#FFFFFF",
    frequentlyOrderedItemSubText: "#505050",
    giftCardBalanceColor: "#606060",
    mobileDividerColor: "rgba(0,0,0,0.5)",
    homescreenPromoBackdrop: "rgba(0, 0, 0, 0.6)",
    fullHomescreenPromoBg: "#F8F7F6",
    paymentScreenImportantTextDescription: "#808080",
    curbsideBannerTagColor: "#FFFFFF",
    guestFavoritesBackgroundColor: "#F6F6F6",
    guestFavouritePopOverBGColor: "#F3F4E7",
    guestPopoverBackdropColor: "rgba(0,0,0,0.7)",
    mobilePayBgColor: "#FFFFFF",
    mobilePayDividerColor: "#C6C6C6",
    mobilePayDividerTextColor: "#808080",
    mobilePayWorksHeaderTextColor: "#404040",
    mobilePayWorksListItemBgColor: "#F6F6F6",
    mobilePayWorksTitleColor: "#303030",
    mobilePayWorksItemTitleColor: "#2A2C25",
    mobilePayGuidlineBgColor: "#F6F6F6",
    mobilePayWhiteTextColor: "#FFFFFF",
    reorderTopTabScreenBackgroundColor: "#F6F6F6",
    errorPopUpContentDividerBackgroundColor: "#F6F6F6",
    howMobilePayWorksModalBg: "rgba(0,0,0,0.6)",
    menuSliderSelectedCountTextColor: "#808080",
    menuCustomisationButtonColor: "#A2794D",
    menuCustomisationIsSelectedMobileColor: "#F9F8F1",
    menuCustomisationIsSelectedBorderMobileColor: "#A2794D",
    menuCustomisationNotSelectedBorderMobileColor: "#C6C6C6",
    joinWaitListMapTextColor: "#464838",
    joinWaitlistBackgroundColor: "#F6F6F6",
    selectedNumberOfGuestBorderColor: "#A1784D",
    selectedNumberOfGuestBackgroundColor: "#A1784D",
    backgroundWhite: "#fff",
    menuCustomisationListIItemActiveColour: "#a18e82",
    collapsableDropdownItemBgColor: "#F6F6F6",
    smartRecommendationBackgroundColor: "#E5E5E5",
    smartRecommendationActiveDotColor: "#54301A",
    smartRecommendationInActiveDotColor: "#C6C6C6",
    unavailableWaitlistColor: "#BDBDBD",
    mobileReorderScreenTitleColor: "#2A2C25",
    checkoutRadioButtonBorderColor: "#D6D6D6",
    pickupMethodBackgroundColor: "#F6F6F6",
    pickupMethodSectionDivider: "#DCDCDC",
    // Menu Search Start
    suggestedSearchTextColor: "#404040",
    noResultFoundMenuSearchBg: "#F6F6F6",
    searchModalBackgroundColor: "white",
    menuSearchModalDivider: "#ABABAB",
    searchCardCategorySlugColor: "grey",
    inputFieldBackgroundColor: "#F6F6F6",
    suggestionsBorderColor: "#C6C6C6",
    clearTextColor: "#993324",
    noResultTextColor: "#A1784D",
    backgroundE5E5: "#E5E5E5",
    // Menu Search End
    ///Order Ahead Flow Tokens
    serveAsEntreeSwitch: "#A1784D",
    reservationsSpecialRequestSwitch: "#A1784D",
    //mobile Payment Options tokens
    paymentOptionsHeaderColor: "#F9F8F1",
    paymentOptionsBorderColor: "#DCDCDC",
    //mobile app profile
    editProfileInfoLabelColor: "#808080",
    editProfileInfoAsteriskColor: "#D30000",
    profilePictureShadowColor: "#000000",
    mobileOrderInfoBannerBorderColor: "#D6D6D6",
    // order tracking page end
    //mobile restaurant details skeleton
    skeletonColorGrey: "#DCDCDC",
    onboardingScreenBGColor: "#FFFFFF",
    onboardingActiveDotColor: "#54301A",
    onboardingInactiveDotColor: "rgba(0,0,0, 0.2)",
    onboardingButtonBackgroundColor: "#A1784D",
    orderDetailsSkeletonBgColor: "#C4C4C4",
    //tab bar
    backgroundTabBarColor: "white",
    shadowColor: "#2c2c2c",
    //home-screen header avatar
    homeScreenHeaderAvatarBg: "lightgrey",
    //menu-collapsable bg
    menuCollapsableButton: "#F9F8F1",
    //number of guests bg
    numberOfGuestsActiveColor: "#FFFFFF",
    // estimated waitTime bg
    estimatedWaitTimeBg: "#54301A",
    // cart item qty color
    cartItemQuantityColor: "#54301A",
    mobileBottomTabBackgroundColor: "#FFFFFF",
    bottomTabTextColor: "#282C25",
    checkoutGratuitySliderMinTrackColor: "#A1784D",
    checkoutGratuitySliderMaxTrackColor: "#BFBFBF",
    cartQuantityTextColor: "#54301A",
    checkoutRadioBtnColor: "#A1784D",
    // waitlistWineWhileYouWait Background color:
    waitlistWineWhileYouWaitBg: "#FFEFC2",
    homescreenWaitlistButtonBorderColor: "#A1784D",
    homescreenWaitlistButtonTextColor: "#A1784D",
    recentOrderTextColor: "#303030",
    orderConfirmationSeeDetailsShadowStart: "rgba(0, 0, 0, 0.02)",
    orderConfirmationSeeDetailsShadowEnd: "rgba(0, 0, 0, 0.05)",
    // statuses colours:
    highWait: "#CA7C30",
    lowWait: "#A8AD00",
    waitNotAvailable: "#BDBDBD",
    recentOrdersListItemPrice: "#80603D",
    menuLinearGradientStartColor: "#F8F8F8",
    menuLinearGradientEndColor: "#F8F8F8",
    paymentOrderTotalTextColor: "#A1784D",
    keyboardDoneButtonBgColor: "#FBFBFB",
    keyboardDoneButtonColor: "#2c7aff",
    profileHeaderLinearGradientStartColor: "#A1784D",
    profileHeaderLinearGradientEndColor: "#6A4A27",
    profileAddCardButtonText: "#A1784D",
    searchBarBorderColor: "#D6D6D6",
    weekDayStartColor: "#A1784D",
    weekDayEndColor: "#A1784D",
    mobilePayConfirmationScreenBlockBG: "#F9F8F1",
    reservationCarouselActiveDotColor: "#DDC274",
    reservationCarouselInactiveDotColor: "#D5D8DA",
    reservationBorderColor: "rgba(0,0,0,0.1)",
    reservationButtonBGDisabled: "#CBD1D6",
    reservationSelectedCTABorderColor: "#A1784D",
    reservationUnSelectedCTABorderColor: "transparent",
    reservationSelectedCTABGColor: "#F9F8F1",
    reservationUnSelectedCTABGColor: "#FFF",
    reservationPopupBgColor: "#fff",
    locationsTopTabsContainerColor: "#FFFFFF",
    searchItemBreadCrumbSlugcolor: "#666666",
    preferredLocationHeaderBg: "#FFFFFF",
    preferredLocationHeaderTextColor: "#303030",
    orderTotalTextColor: "#A1784D",
    orderTotalPriceColor: "#A1784D",
    scrollingNavigationFlatlistStartingGradientStartColor: "#f8f8f8",
    scrollingNavigationFlatlistStartingGradientEndColor: "rgba(248, 248, 248, 0)",
    menuSearchModalCloseIconBg: "#F9F8F1",
    // RESTAURANT DETAILS START
    restaurantDetailsBGColor: "white",
    restaurantDetailsDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsAboutSectionDividerColor: "rgba(0,0,0,0)",
    restaurantDetailsMobilePoliteNoticeDividerBg: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerMobileColor: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerColor: "transparent",
    restaurantDetailsJoinWaitlistButtonTextColor: "#A2402A",
    restaurantDetailsJoinWaitlistButtonBorderColor: "#A2402A",
    restaurantDetailsJoinWaitlistButtonLargeTextColor: "white",
    restaurantDetailsDisableJoinWaitlistTextColor: "#C6C6C6",
    restaurantDetailsDisableJoinWaitlistButtonBorderColor: "#C6C6C6",
    restaurantDetailsCurrentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsRestInfoBoxBackgroundColor: "#F3F4EA",
    restaurantDetailsRestInfoLgDividerBackgroundColor: "#0000004D",
    restaurantDetailsSelectedWeekDayColor: "#A07850",
    restaurantDetailsNotSelectedWeekDayTextColor: "#303030",
    restaurantDetailsNotSelectedWeekDayColor: "#FFFFFF",
    restaurantDetailsCurrentWeekDayIndicator: "#49909B",
    restaurantTimingWeekDayTextColor: "#4E311D",
    // mobileOrderHistoryItemCardHeaderBackgroundColor: "#FAF2EE",
    restDetailsRestInfoTitleColor: "#020001",
    // restaurantInfoNumberAndDistanceTextColor: "#782434",
    restDetailsName: "#55111E",
    jwcArrowColor: "#80603D",
    // RESTAURANT DETAILS END
    waitlistStatusScreenBg: "#F9F8F1",
    waitlistVisibilityAddressBoxArrow: "#54301A",
    howItWorksText: "#A1784D",
    waitlistVisibilityModalBg: "#000000B2",
    imageStackBorderColor: "#FFFFFF",
    calenderTodayBackgroundColor: "#A1784D",
    calenderSelectedDayColor: "#A1784D",
    calenderSelectedDayTextColor: "#FFFFFF",
    calenderSelectedDayStyleBGColor: "#A1784D",
    reserveTableHeaderRightButtonText: "#A1784D",
    reserveConfirmationDescriptionHeaderBg: "#485062",
    defaultCardColor: "#rgba(255, 255, 255, 0.3)",
    defaultCardTextColor: "#FFFFFF",
    mobilePayBringYourCardArea: "#E0DFD9",
    mobilePayCheckArea: "#F2F2F2",
    mobilePayCallInCheckDivider: "rgba(0, 0, 0, 0.1)",
    mobilePaySkeletonColor: "#DCDCDC",
    noOfGuestsLabelColor: "#808080",
    mobilePayCheckCloseBackgroundColor: "#F4F4F4",
    mobilePayCheckDividerColor: "rgba(0, 0, 0, 0.4)",
    mobilePayCheckBackground: "#FFFFFF",
    waitlistTableRowSeperator: "#F6F6F6",
    waitlistTableInfoBg: "#606060",
    waitlistTableInfoText: "#FFFFFF",
    homescreenLocationTagBGColor: "rgba(255, 255, 255, 0.68)",
    homescreenLocationTagBorderColor: "#A1784D",
    homescreenLocationTextColor: "#303030",
    // location Search Token
    locationSearchTitle: "#303030",
    locationSearchSubTitle: "#020001",
    locationSearchActiveTab: "#A1784D",
    locationSearchActive3Tab: "#A2794D",
    locationSearchActive3TabTextColor: "#FFFFFF",
    locationSearchInActive3TabTextColor: "#606060",
    locationSearch3Tabs: "#E5E4E0",
    searchBarBackgroundForThreeTabs: "#F2F0F0",
    searchThisAreaBg: "#A1784D",
    locationSearchInActiveTab: "#606060",
    searchCurrentLocation: "#A1784D",
    registerLsBtn: "#A1784D",
    callRestLsText: "#A1784D",
    mobilePayICheckError: "#3F3C3C",
    locationListingItemHeadingInPage: "#A1784D",
    locationListItemDistanceText: "#54301A",
    locationSearchTabDivider: "#DEDEDE",
    lsAllLocationsSelectBorder: "#DEDEDE",
    locationSearchAddressColor: "#020001",
    locationsSearchPageLocationListItemBgColor: "#ffff",
    lsMyLocationsTabContentDivider: "#0000001a",
    hoursInfoAccordionIcon: "#A1784D",
    hoursInfoAccordionTitle: "#A07850",
    joinWaitlistBtnHover: "white",
    joinWaitlistBtnTextHover: "#A1784D",
    loginScreenHeaderBackground: "white",
    loginScreenScrollBg: "white",
    createAccountZipCodeBg: "#FFFFFF",
    createAccountLocationCardBackgroundColor: "#FFFFFF",
    loginErrorMessageBg: "#FECACA",
    loginErrorMessageBorder: "#FCA5A5",
    preferredLocationScrollBg: "#FFFFFF",
    menuListingScrollBackground: "#FFFFFF",
    cartCheckoutButtonLinearGradientStart: "rgba(255,255,255,0.6)",
    cartCheckoutButtonLinearGradientEnd: "#FFF",
    menuListingTopTabsColor: "#FFF",
    cartHeaderTextColor: "#000",
    menuListingTopTabActiveBorderColor: "#A1784D",
    dividerBackgroundColor: "#E5E5E5",
    moreHeaderTitleTextColor: "#000000",
    customMobileHeaderBG: "#FFFFFF",
    addCardSecurityBannerBg: "#F6F7F0",
    mobileCreateAccountScrollBackgroundColor: "transparent",
    menuTopTabNotActiveTextColor: "#171717",
    menuTopTabActiveTextColor: "#A1784D",
    checkoutTopTabActiveTextColor: "#171717",
    checkoutTopTabTextColor: "#171717",
    checkoutCardsBg: "transparent",
    orderInfoBannerCartSubTotalColor: "#A1784D",
    orderSettingsCardsBackgroundColor: "transparent",
    orderSettingsActionSheetBackgroundColor: "#FFF",
    orderSettingsActionSheetAsapScheduledColor: "#A1784D",
    menuItemDetailMenuSummaryBackgroundColor: "#FFF",
    menuitemDetailScreenBackgroundColor: "#FFF",
    cartHeaderBGColor: "#F6F6F6",
    nearbyLocationsListViewScrollViewBgColor: "#FFF",
    menuSearchResultsBg: "#fff",
    searchHeaderColor: "#fff",
    menuSearchPlaceHolder: "#606060",
    recentOrderDividerBg: "#E5E5E5",
    restDetailsTitleColor: "#2A2C25",
    restDetailsBg: "#fff",
    restDetailButtonBg: "#fff",
    recentOrderBorder: "#F2EFEA",
    tooltipTextColor: "#fff",
    pickupDetailsBorder: "#D6D6D6",
    checkoutVehicleBg: "#fff",
    seeDetailsText: "#606060",
    orderSettingsQuantityBg: "#F9F8F1",
    criticalModeBg: "#fafafa",
    newLoctionsLinkText: "#ffffff",
    newLocationsBannerBg: "#80603D",
    reorderAddItemBg: "#A1784D",
    reorderAddItem: "#fff",
    orderHistoryItemCardBackgroundColor: "#FFF",
    orderHistoryItemCardPriceColor: "#A1784D",
    orderHistoryHeaderTitleColor: "#2A2C25",
    orderHistoryDetailsOrderNumberTextColor: "#A1784D",
    orderHistoryCardLayoutBackgroundColor: "#FFF",
    orderHistoryFooterBackgroundColor: "#FFF",
    orderHistoryHeaderBgColor: "#FFF",
    menuDetailsHeaderTitleColor: "#404040",
    selectedOrderTypeBorderColor: "#A1784D",
    selectedOrderTypeTextColor: "#A1784D",
    mobileCalendarTextColor: "#A1784D",
    gcBalanceRefreshBorderTextColor: "#A1784D",
    gcBalanceRefreshBackdropColor: "rgba(0, 0, 0, 0.6)",
    reservationSelectedSeatingOption: "#A1784D26",
    reservationCalendarCtaBorderRadius: 6,
    reservationDOBMonthBgColor: "#fff",
    reservationDOBYearBgColor: "#fff",
    reservationDOBNavColor: "primary.100",
    reservationInputErrorColor: "#DF4505",
    reservationLocationModalDeskHeaderBg: "#FFF",
    reservationLocationModalMobHeaderBg: "#FFF",
    reservationLocationListBg: "#FFF",
    reservationBg: "#F6F6F6",
    reservationStaticTextBg: "#F2EFEA",
    reservationTabsBg: "#A1784D",
    reservationPickerHoverColor: "#A1784D",
    reservationNoOfGuestsSelectedBg: "#A1784D",
    reservationNoOfGuestsNotSelectedBg: "white",
    reservationsTimePickerBg: "white",
    reservationActionButtonsBg: "white",
    reservationInactiveSelectTime: "#D8DCE0",
    reservationDropDownIconColor: "#020001",
    confirmationModalBorderRadius: 4,
    cancelConfirmationModalBorderRadius: 8,
    reservationUserInitials: "#A1784D",
    preferredLocationCloseButtonBg: "#F9F8F1",
    preferredLocationCloseButtonHover: "#F9F8F1",
    preferredLocationModalContentColor: "#FFFFFF",
    preferredLocationCloseButtonIconColor: "#A1784D",
    reservationHoveredText: "#FFF",
    reservationNotHoveredText: "#606060",
    reservationsCardsBodyBg: "#F6F6F6",
    reservationSpecialRequests: "#FFFFFF",
    reservationsCardBg: "#fff",
    reservationDOBTooltipBgColor: "#e3e3e3",
    reservationDOBTooltipTextColor: "#000"
  },
  components: {
    Pressable: {
      variants: {
        /* RESERVATION */
        reservationLocationSelectionBtn: {
          borderRadius: 6,
          px: 10,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center"
        },
        reservationConfBackHomeBtn: {
          borderRadius: 6,
          alignItems: "center",
          justifyContent: "center",
          mb: 30,
          mx: 5,
          px: 5,
          mt: 5,
          borderWidth: 1,
          height: 12,
          borderColor: "secondary.300"
        },
        reservationSelectGuestBtn: {
          borderColor: "reservationBorderColor",
          borderWidth: 1,
          py: 3,
          px: 5,
          mx: 1.5,
          borderRadius: 4,
          _ios: {
            radiusValue: 6
          },
          _android: {
            radiusValue: 6
          }
        },
        reservationPickerBtn: {
          flex: 1,
          py: 2,
          _web: {
            py: 4,
            px: 4
          },
          _ios: {
            alignItems: "center"
          },
          _android: {
            alignItems: "center"
          },
          mx: 1.5,
          borderRadius: 8,
          justifyContent: "center"
        },
        reservationAvailableTimeSlotBtn: {
          borderColor: "reservationBorderColor",
          borderRadius: 0,
          mx: 2
        },

        /* RESERVATION */
        jwcPreOrderBtn: {
          px: 5,
          py: 4,
          bg: {
            base: "#A2402A",
            lg: "white"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        qualityStoryBtnCta: {
          px: 5,
          py: 4,
          bg: {
            base: "#ffffff",
            lg: "#ffffff"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        //Order Tracking
        orderTrackingCurbsideCheckPrimary: {
          bg: "payNowButtonBg",
          borderColor: "curbsideCheckInSecondary",
          borderWidth: 1,
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        orderTrackingCurbsideCheckSecondary: {
          bg: "#FFFFFF",
          borderColor: "curbsideCheckInSecondary",
          px: 5,
          py: 3,
          borderWidth: 1,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        // JOIN WAITLIST START
        joinWaitlist_Guests_Number_Container: function joinWaitlist_Guests_Number_Container(_ref) {
          var selected = _ref.selected;
          return {
            shadow: selected ? 8 : "none",
            width: "56px",
            height: "51px",
            bg: selected ? "secondary.300" : "white",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 6,
            borderWidth: 1,
            borderColor: selected ? "secondary.300" : "#DEDEDE"
          };
        },
        joinWaitlist_CTA_Cancel_Button: function joinWaitlist_CTA_Cancel_Button() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: 4,
            px: {
              lg: 24
            },
            borderWidth: 1,
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        joinWaitlist_CTA_JW_Button: function joinWaitlist_CTA_JW_Button(_ref2) {
          var disabled = _ref2.disabled;
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: 4,
            px: {
              lg: 20
            },
            borderWidth: 1,
            borderColor: disabled ? "#C9C9C9" : "#A1784D",
            bgColor: disabled ? "#C9C9C9" : "#A1784D"
          };
        },
        // JOIN WAITLIST END
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        suggestedSearchPill: {
          mt: 2,
          mb: 2,
          mr: 3,
          py: 2,
          px: 4,
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          bg: "#FFFFFF",
          borderColor: "suggestionsBorderColor",
          borderRadius: 50
        },
        //Restaurant Details Start
        restaurantDetails_RestWaitlist_JoinWaitlistButton: function restaurantDetails_RestWaitlist_JoinWaitlistButton(_ref3) {
          var disabled = _ref3.disabled;
          return {
            borderRadius: 5,
            borderColor: disabled ? "#BCBCBC" : "#A1784D",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 1,
            _ios: {
              py: 2
            },
            _android: {
              py: 2
            },
            bg: disabled ? "transparent" : "#A1784D",
            minWidth: {
              base: "70%",
              lg: "261px"
            },
            _web: {
              minH: "48px"
            }
          };
        },
        restaurantDetails_OrderButtonSection_OrderNowButton: function restaurantDetails_OrderButtonSection_OrderNowButton(_ref4) {
          var disabled = _ref4.disabled;
          return {
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "secondary.300",
            borderRadius: 8,
            opacity: disabled ? 0.4 : 1,
            borderWidth: 1,
            width: "100%",
            disabled: disabled,
            _web: {
              minH: "48px",
              padding: 2
            },
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconButton: function restaurantDetails_RestTimings_WeekDayIconButton(_ref5) {
          var selectedDay = _ref5.selectedDay;
          return {
            borderRadius: 100,
            backgroundColor: selectedDay ? "restaurantDetailsSelectedWeekDayColor" : "restaurantDetailsNotSelectedWeekDayColor",
            width: 38,
            height: 38,
            borderColor: "weekDayBorderColor",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center"
          };
        },
        restaurantDetails_ActionButtons_ApplyNowButton: function restaurantDetails_ActionButtons_ApplyNowButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: 4,
            _web: {
              minH: "48px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: {
              base: "#A1784D",
              lg: "amenitiesActionButtonsColor"
            }
          };
        },
        restaurantDetails_ActionButtons_ViewMenuButton: function restaurantDetails_ActionButtons_ViewMenuButton(_ref6) {
          var btnPadding = _ref6.btnPadding;
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: btnPadding ? btnPadding : 4,
            _web: {
              minH: "48px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: {
              base: "#A1784D",
              lg: "amenitiesActionButtonsColor"
            }
          };
        },
        restaurantDetails_RestaurantInfo_FavoriteButton: function restaurantDetails_RestaurantInfo_FavoriteButton() {
          return {
            bg: "white",
            w: "10",
            h: "10",
            shadow: 11,
            m: "auto",
            rounded: "full",
            position: "absolute",
            top: 2,
            right: 2
          };
        },
        restaurantDetails_RestInfo_ShareButton_Icon: {
          alignItems: "center",
          flexDirection: "row"
        },
        borderRadiusValue: function borderRadiusValue(_ref7) {
          var radiusValue = _ref7.radiusValue,
              topRadiusValue = _ref7.topRadiusValue,
              bottomRadiusValue = _ref7.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        //Restaurant Details End
        viewCartBtnBorderRadius: {
          _ios: {
            borderRadius: 8
          },
          _android: {
            borderRadius: 8
          }
        },
        homeScreen_order_button: function homeScreen_order_button() {
          return {
            shadow: 9,
            backgroundColor: "secondary.300",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%"
          };
        }
      }
    },
    Button: {
      variants: {
        solid: {
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#7C5D3C"
          }
        },
        ghost: {
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            bg: "background.100"
          }
        },
        remoteCheckinBodyBtn: {
          mt: 3,
          bg: "#A1784D",
          pt: 3,
          _web: {
            width: {
              base: "80%",
              sm: "80%",
              md: "100%"
            }
          },
          pb: 3,
          _hover: {
            bg: "#7C5D3C"
          }
        },
        refreshIcon: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "white",
          borderColor: "#A1784D",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "secondary.300",
            fontWeight: 400
          }
        },
        camAccessBtn: {
          bg: "#A1784D",
          paddingY: 18,
          marginTop: 27,
          marginX: 5,
          borderWidth: 1,
          w: "100%",
          _text: {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        socialLoginBtn: {
          bg: "transparent",
          mb: 4,
          border: 1,
          borderColor: "rgb(53,88,156)",
          borderRadius: 4,
          _text: {
            fontWeight: 400,
            color: "rgb(53,88,156)"
          },
          _hover: {
            bg: "white"
          }
        },
        addMoreItemsButton: {
          _ios: {
            width: "100%",
            py: 4
          },
          _android: {
            width: "100%",
            py: 4
          },
          _web: {
            width: "100%",
            py: 2
          }
        },
        loginPopUpBtn: {
          borderRadius: 4,
          height: 12,
          _web: {
            height: null
          },
          _text: {
            color: "white",
            fontWeight: 400
          },
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#7C5D3C"
          }
        },
        menuSearchModalCloseButtonContainer: function menuSearchModalCloseButtonContainer() {
          return {
            _web: {
              marginRight: {
                base: "20px",
                md: "40px",
                lg: "110px"
              },
              marginTop: "26px",
              height: "48px",
              width: "48px",
              borderRadius: "8px"
            }
          };
        },
        link: {
          _text: {
            textTransform: "uppercase",
            color: "primary.100",
            fontWeight: "600",
            fontStyle: "normal",
            fontSize: "md",
            lineHeight: 6,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            textAlign: "center",
            fontFamily: "headerFont"
          },
          _pressed: {
            bg: "transparent"
          }
        },
        outline: {
          _hover: {
            bg: "#F2E4D5"
          },
          _pressed: {
            bg: "#F2E4D5"
          }
        },
        orderOnlineBtn: function orderOnlineBtn() {
          return {
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase"
            }
          };
        },
        orderOnlineBtnExternalLink: function orderOnlineBtnExternalLink() {
          return {
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase"
            },
            border: 1,
            borderColor: "secondary.300",
            bg: "secondary.300",
            _hover: {
              bg: "secondary.300"
            },
            _pressed: {
              bg: "secondary.300"
            }
          };
        },
        changeLocationLink: {
          _text: {
            textTransform: "uppercase",
            _web: {
              fontSize: "14px"
            },
            fontWeight: "400",
            color: "primary.100",
            fontStyle: "normal",
            lineHeight: 6,
            letterSpacing: "-0.3px",
            textAlign: "center",
            fontFamily: "headerFont"
          },
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            _text: {
              underline: true
            }
          }
        },
        HomeScreenCTAjwl: function HomeScreenCTAjwl(_ref8) {
          var borderRadiusValue = _ref8.borderRadiusValue;
          return {
            marginTop: 5,
            borderRadius: borderRadiusValue || 0
          };
        },
        HomescreenOrderOnlineCta: function HomescreenOrderOnlineCta(_ref9) {
          var borderRadiusValue = _ref9.borderRadiusValue;
          return {
            borderRadius: borderRadiusValue || 0,
            backgroundColor: "secondary.300",
            shadow: 9
          };
        },
        HomeScreenCTAreserveNow: function HomeScreenCTAreserveNow(_ref10) {
          var borderRadiusValue = _ref10.borderRadiusValue;
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            bg: "bodyBg",
            _text: {
              color: "secondary.300"
            }
          };
        },
        cartItemActionButton: {
          _text: {
            color: "cartItemActionBtn",
            textTransform: "uppercase",
            lineHeight: 5,
            fontWeight: 600,
            _ios: {
              fontSize: "13",
              fontWeight: "400"
            },
            _android: {
              fontSize: "13",
              fontWeight: "400"
            },
            _web: {
              fontSize: "13px"
            }
          }
        },
        wcacSecondaryBtn: {
          bg: "white",
          _hover: {
            bg: "#F2E4D5"
          },
          _pressed: {
            bg: "#F2E4D5"
          },
          border: 1,
          borderColor: "#A1784D",
          mr: 3,
          _text: {
            px: 4,
            fontSize: 16,
            fontWeight: 400,
            color: "#A1784D",
            textTransform: "uppercase"
          }
        },
        wcacPrimaryBtn: {
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#7C5D3C"
          },
          _text: {
            px: 2,
            fontSize: 16,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        cartItemRemoveBtn: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "secondary.300",
          borderColor: "secondary.300",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "white",
            fontWeight: 400
          }
        },
        menuButton: function menuButton(_ref11) {
          var isActive = _ref11.isActive,
              isMobile = _ref11.isMobile,
              isLongText = _ref11.isLongText;
          return {
            px: isMobile ? 6 : 9,
            bg: isActive ? "menuButtonBackgroundColor" : "transparent",
            _web: {
              width: !isMobile && (isLongText ? "100%" : "117px"),
              borderReadis: "17px"
            },
            width: 32,
            borderReadis: 4,
            height: {
              base: 8,
              md: 9
            },
            rounded: "full",
            _text: {
              _web: {
                lineHeight: isMobile ? "14.63px" : "24px",
                fontSize: {
                  base: "12px",
                  md: "14px"
                }
              },
              lineHeight: isMobile ? 4 : 6,
              color: isActive ? "white" : "menuButtonBackgroundColor",
              fontWeight: "600",
              fontSize: isMobile ? "xs" : "sm",
              textTransform: "uppercase",
              fontFamily: "heading"
            }
          };
        },
        pillButton: function pillButton(_ref12) {
          var isActive = _ref12.isActive;
          return {
            bg: isActive ? "secondary.100" : "transparent",
            _web: {
              borderRadius: "20px",
              height: "24px"
            },
            borderRadius: 5,
            height: 6
          };
        },
        exploreMenuButton: function exploreMenuButton() {
          return {
            bg: "white",
            border: 1,
            borderColor: "primary.100",
            _text: {
              color: "primary.100"
            }
          };
        },
        orderSettingsDateTimeChoiceSolidButton: function orderSettingsDateTimeChoiceSolidButton() {
          return {
            bg: "primary.100"
          };
        },
        addToCartSolidButton: function addToCartSolidButton(_ref13) {
          var isUnavailable = _ref13.isUnavailable;
          return {
            bg: isUnavailable ? "#E5E5E5" : "primary.100",
            _pressed: {
              bg: isUnavailable ? "#E5E5E5" : "primary.100"
            },
            _hover: {
              bg: isUnavailable ? "#E5E5E5" : "primary.100"
            }
          };
        },
        addBtnPadding: function addBtnPadding() {
          return {
            _web: {
              paddingBottom: "8px"
            },
            paddingBottom: 2
          };
        },
        confirmationGradientButton: function confirmationGradientButton() {
          return {
            borderRadius: 8
          };
        },
        waitlistOrder: {
          backgroundColor: "white",
          borderColor: "#A1784D",
          borderWidth: 1
        },
        waitlistFooterHowItWorks: {
          fontWeight: 500,
          color: "#80603D"
        },
        myLocationsLoginText: {
          fontWeight: 600,
          fontSize: 18,
          color: "secondary.300",
          textTransform: "uppercase"
        },
        //Restaurant Details Start
        restaurantDetails_RestInfo_GetDirectionsButton: function restaurantDetails_RestInfo_GetDirectionsButton() {
          return {
            variant: "outline",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "amenitiesActionButtonsColor",
            alignSelf: "flex-end",
            borderWidth: 1,
            bg: "white",
            _hover: {
              bg: "white"
            },
            _focus: {
              bg: "white"
            },
            _focusVisible: {
              bg: "white"
            },
            py: 2.5,
            px: 2
          };
        },
        //Restaurant Details End
        preorderDineIn: {
          backgroundColor: "#A1784D"
        },
        // LS page
        locationListItemButtonBorderRadius: 6,
        locationsInfographicLoginButton: function locationsInfographicLoginButton() {
          return {
            pr: 12,
            pl: 12,
            py: 3,
            backgroundColor: "secondary.300",
            borderRadius: 6,
            _text: {
              color: "locationInfographicModalActionButtonTextColor",
              fontSize: 20,
              fontWeight: 400,
              textTransform: "uppercase",
              textAlign: "center",
              lineHeight: 6
            }
          };
        },
        defaultBannerBtn: function defaultBannerBtn() {
          return {
            _web: {
              minW: 134,
              px: 4,
              py: 2
            },
            _ios: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            _android: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            px: 4,
            py: 2,
            borderWidth: 1,
            borderColor: "primary.200",
            bg: "primary.100"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref14) {
          var radiusValue = _ref14.radiusValue,
              topRadiusValue = _ref14.topRadiusValue,
              bottomRadiusValue = _ref14.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        viewNutritionalVariant: {
          py: 1,
          mb: 2
        },
        confirmBtnBorderRadius: {
          borderRadius: 8
        },
        homeScreen_reserve_button: function homeScreen_reserve_button() {
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%",
            bg: "bodyBg",
            _pressed: {
              bg: "bodyBg"
            },
            _text: {
              _ios: {
                fontSize: 18
              },
              _android: {
                fontSize: 18
              },
              _web: {
                fontSize: 18
              },
              color: "secondary.300",
              fontWeight: 400,
              lineHeight: 7,
              paddingTop: Platform.OS === "ios" ? 1 : 0,
              marginY: 0.5
            }
          };
        },
        joinWaitlist_Header_LoginButton: function joinWaitlist_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "primary.100",
              fontWeight: 400
            },
            borderColor: "primary.100",
            borderRadius: 6,
            px: "17px",
            py: "10px",
            _web: {
              px: {
                base: "10px",
                lg: "17px"
              },
              py: {
                base: "6px",
                lg: "10px"
              }
            },
            _focus: {
              backgroundColor: "white"
            },
            bg: "transparent",
            borderWidth: 1
          };
        }
      }
    },
    Tooltip: {
      baseStyle: {
        borderRadius: 8,
        padding: 3,
        _text: {
          fontSize: 12,
          fontWeight: 500
        }
      }
    },
    Accordion: {
      baseStyle: {
        borderWidth: 0,
        borderColor: "transparent",
        borderRadius: 0
      },
      variants: {
        skuSelectorAccordion: function skuSelectorAccordion(_ref15) {
          var isMandatory = _ref15.isMandatory;
          return {
            borderRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemAccordion: function menuItemAccordion() {
          return {
            borderRadius: {
              md: "10"
            }
          };
        }
      }
    },
    ModalHeader: {
      variants: {
        errorDialogModalHeader: {
          roundedTop: 8
        }
      }
    },
    ModalContent: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref16) {
          var radiusValue = _ref16.radiusValue,
              topRadiusValue = _ref16.topRadiusValue,
              bottomRadiusValue = _ref16.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    AccordionSummary: {
      baseStyle: {
        borderTopWidth: 0,
        borderTopColor: "transparent",
        p: 0,
        _hover: {
          bg: "transparent"
        },
        _expanded: {
          bg: "transparent",
          borderBottomColor: "transparent",
          _text: {
            color: "white"
          }
        },
        _disabled: {
          bg: "transparent"
        }
      },
      variants: {
        skuSelectorSummary: function skuSelectorSummary(_ref17) {
          var isMandatory = _ref17.isMandatory;
          return {
            borderTopRadius: {
              md: isMandatory && "xl"
            }
          };
        }
      }
    },
    AccordionDetails: {
      variants: {
        skuSelectorDetails: function skuSelectorDetails(_ref18) {
          var isMandatory = _ref18.isMandatory;
          return {
            borderBottomRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemDetails: function menuItemDetails(_ref19) {
          var isDefaultExpanded = _ref19.isDefaultExpanded;
          return {
            borderBottomRadius: {
              md: isDefaultExpanded && "xl"
            }
          };
        }
      }
    },
    Stack: {
      variants: {
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_Container: function joinWaitlist_StaticMap_Container() {
          return {
            flexDirection: {
              md: "row"
            },
            m: 5,
            borderRadius: 16,
            overflow: "hidden",
            shadow: 10
          };
        },
        // JOIN WAITLIST END
        skuSelectorItem: {
          borderRadius: 12
        },
        //Restaurant Details Start
        restaurantDetails_CurrentStatusAndWaitlist_AvailabilityStack: {
          alignItems: {
            lg: "flex"
          },
          _ios: {
            marginTop: 3
          },
          _android: {
            marginTop: 3
          },
          direction: {
            base: "row",
            lg: "column"
          },
          justifyContent: "space-between",
          space: "md"
        },
        restaurantDetails_CurrentStatusAndWaitlist_WaitTimeStack: {
          _ios: {
            marginRight: 4
          },
          _android: {
            marginRight: 4
          },
          direction: {
            base: "column",
            lg: "row"
          },
          alignItems: "center",
          space: {
            lg: "sm"
          }
        },
        restaurantDetails_RestInfo_AddressLink_Stack: {
          direction: {
            base: "column",
            lg: "row"
          }
        } //Restaurant Details End

      }
    },
    Divider: {
      variants: {
        restaurantDetails_RestInfo_Divider: {
          mx: 5
        },
        jwcFooterBlockDivider: {
          height: 4,
          backgroundColor: "#8A8585",
          orientation: "vertical",
          mx: 6,
          w: 0.4
        }
      }
    },
    Text: {
      variants: {
        /* RESERVATION */
        reservationListHeaderUpcoming: {
          fontSize: 18,
          fontWeight: 800,
          pb: 4
        },
        reservationCancelSuccessHeader: {
          fontSize: 20,
          fontWeight: 500,
          textAlign: "center",
          color: "#303030"
        },
        reservationPoliteDressText: {
          fontSize: 14,
          fontWeight: 300,
          pt: 2
        },
        reservationMakeNewReservationCTA: {
          fontWeight: 500,
          fontSize: 20,
          color: "primary.100",
          textAlign: "center"
        },
        reservationCancelSuccessBody: {
          fontSize: 16,
          fontWeight: 200,
          color: "#606060",
          lineHeight: 5,
          textAlign: "center"
        },
        reservtionPredferedLocationCardAddress: {
          fontWeight: "300",
          fontSize: 12,
          lineHeight: 4
        },
        reservationConfirmationDateTimeSizeText: {
          fontWeight: 400,
          lineHeight: 5,
          fontSize: 14
        },
        reservationConfirmationRestaurantName: {
          fontSize: {
            base: 14,
            md: 16
          },
          fontWeight: 400,
          lineHeight: 5,
          flexWrap: "wrap"
        },
        reservationConfirmationLocationAddress: {
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 300,
          lineHeight: 5,
          flexWrap: "wrap"
        },
        reservationConfirmationDirectionsText: {
          fontWeight: 400
        },
        reservationsSelectFromAvailableSlotsTitle: {
          fontWeight: 500
        },
        reservationsReviewReservationsText: {
          fontWeight: 500
        },
        reservationsChangeLocationChangeText: {
          color: "primary.100",
          textTransform: "uppercase",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 400
        },
        reservationThankyouConfirmationText: {
          fontSize: 18,
          fontWeight: 500,
          pb: 2,
          color: "primary.100",
          textAlign: "center"
        },
        reservationThankyouConfirmationSubText: {
          fontSize: 16,
          fontWeight: 500,
          textAlign: "center"
        },
        reservationSelectGuestText: {
          fontSize: 14,
          color: "#606060",
          fontWeight: 200
        },
        reservationLocationCardHeader: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400
        },
        reservationLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200,
          color: "#303030"
        },
        reservationLocationModalHeaderText: {
          color: "#282C25",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        reservationFilterStateHeading: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 500,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        reservationTabsText: function reservationTabsText(_ref20) {
          var isActive = _ref20.isActive;
          return {
            textAlign: "center",
            color: isActive ? "#000" : "#FFF",
            opacity: isActive ? 1 : 0.7,
            fontSize: {
              base: 18,
              md: 20
            },
            mt: 2
          };
        },
        reservationDetailsHeaderText: {
          px: 5,
          fontSize: 20,
          fontWeight: 500,
          lineHeight: 5,
          color: "grey300"
        },
        reservationPickerTopLabelText: {
          pb: 2,
          noOfLines: 1,
          fontSize: 14,
          color: "#707070",
          _web: {
            pb: 0,
            mb: {
              base: 1,
              md: 0
            }
          }
        },
        reservationPickerLabelText: {
          pt: 2,
          noOfLines: 1,
          fontSize: 16,
          fontWeight: 300,
          _web: {
            pt: 0,
            mt: 1,
            width: "min-content",
            borderBottomWidth: 1
          }
        },
        reservationAddDetailsHeading: {
          px: 5,
          fontSize: 20,
          fontWeight: 500,
          lineHeight: 5,
          color: "grey300"
        },

        /* RESERVATION */
        advanceOrderMessageText: {
          fontWeight: 400,
          color: "#FF0000",
          fontSize: [12, 12, 14, 14, 14]
        },
        errorDialogBoxTitle: {
          fontSize: "lg",
          fontWeight: 400
        },
        OnboardingScreenTitleTextColor: {
          color: "#303030"
        },
        //checkDetails Start
        cdHeaderText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdCheckItemsText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdBillingTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdTableDetailTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        successDialogTitleText: {
          lineHeight: 4
        },
        successDialogDescText: {
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          }
        },
        orderConfirmationMobileNumberText: {
          lineHeight: 3
        },
        //checkDetails End
        // checkSummaryStart
        paymentCompleteText: {
          fontSize: 18,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        checkSummaryTitle: {
          fontSize: 22,
          color: "secondary200Mobile",
          fontWeight: 500,
          fontFamily: "headingSecondary",
          lineHeight: 6
        },
        checkSummaryBodyText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        checkSummaryEmailText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 5,
          color: "#020001"
        },
        checkSummarySurveyText: {
          color: "secondary200Mobile",
          fontWeight: 500,
          lineHeight: 6,
          fontSize: 14
        },
        checkSummaryPriceText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        totalPriceText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        preAppliedDeductionPrice: {
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 5
        },
        // checkSummaryEnds
        paymentTileTitle: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "orderTotalTextColor"
        },
        paymentTilePrice: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "#55111E"
        },
        paymentMethodsText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        OrderInfoBannerCartIconText: {
          _web: {
            pt: 1
          }
        },
        LoginHeaderText: {
          pt: 1
        },
        checkoutTopLabelText: {
          pt: 1
        },
        emailReceiptText: {
          fontSize: 20,
          lineHeight: 5,
          fontWeight: 500,
          fontFamily: "headingSecondary",
          color: "#55111E"
        },
        addGratuityText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "#303030"
        },
        camAccessText: {
          color: "#737373",
          lineHeight: 6,
          fontSize: 14
        },
        camAccessLinkText: {
          textDecoration: "underline",
          color: "primary.100"
        },
        gratuityTipNumbers: {
          fontSize: 10,
          color: "themeGrey",
          lineHeight: 3
        },
        snackBarText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary200Mobile"
        },
        snackBarPrice: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary.300"
        },
        stepsToMobilePayHeader: {
          fontFamily: "headingSecondary",
          fontSize: 28,
          color: "#303030",
          textTransform: "uppercase",
          ml: 5
        },
        mobilePayStepsHeading: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 16,
          mt: 4,
          ml: 5,
          color: "#782434",
          _web: {
            letterSpacing: "-0.29px"
          },
          letterSpacing: "-0.29"
        },
        mobilePayStepsBody: {
          fontFamily: "body",
          fontWeight: 200,
          fontSize: 11,
          color: "#303030"
        },
        mobilePayVisitLink: {
          display: "block",
          position: "absolute",
          fontSize: 12,
          lineHeight: 12,
          opacity: "0.4",
          color: "#1B1B1B",
          bottom: "42%",
          left: {
            base: "36%",
            sm: "36%",
            md: "42%",
            lg: "45%"
          },
          textAlign: "center"
        },
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_RestName: function joinWaitlist_StaticMap_RestName() {
          return {
            fontSize: {
              base: 14,
              md: 16
            },
            lineHeight: 4,
            fontWeight: 400,
            color: "grey300",
            mb: 1,
            w: {
              md: "100%"
            },
            _ios: {
              maxW: 300
            },
            _android: {
              maxW: 300
            }
          };
        },
        joinWaitlist_StaticMap_RestAddress: function joinWaitlist_StaticMap_RestAddress() {
          return {
            fontSize: 12,
            fontWeight: 300,
            color: "themeGrey",
            lineHeight: 4,
            mb: 2
          };
        },
        joinWaitlist_StaticMap_ChangeLocation_Web: function joinWaitlist_StaticMap_ChangeLocation_Web() {
          return {
            fontSize: 16,
            color: "secondary.300",
            fontWeight: 400,
            lineHeight: 4,
            mt: 4,
            _ios: {
              textTransform: "uppercase"
            },
            _android: {
              textTransform: "uppercase"
            }
          };
        },
        joinWaitlist_StaticMap_ChangeLocation_Mobile: function joinWaitlist_StaticMap_ChangeLocation_Mobile() {
          return {
            color: "secondary.300",
            fontWeight: 400,
            lineHeight: 4,
            fontSize: {
              base: 12,
              md: 14
            },
            _ios: {
              fontSize: 12,
              textTransform: "uppercase"
            },
            _android: {
              fontSize: 12,
              textTransform: "uppercase"
            }
          };
        },
        joinWaitlist_Guests_Title: function joinWaitlist_Guests_Title() {
          return {
            lineHeight: 4,
            letterSpacing: -0.3,
            fontWeight: 300,
            color: "grey300",
            fontSize: {
              base: "14",
              lg: "16"
            },
            textAlign: "center",
            pl: 4,
            mt: 2,
            mb: 2
          };
        },
        joinWaitlist_Guests_Number: function joinWaitlist_Guests_Number(_ref21) {
          var selected = _ref21.selected;
          return {
            fontSize: {
              base: 16,
              lg: 20
            },
            letterSpacing: -0.3,
            fontWeight: {
              base: "400",
              lg: "300"
            },
            color: selected ? "white" : "themeGrey"
          };
        },
        joinWaitlist_Guests_Note: function joinWaitlist_Guests_Note() {
          return {
            color: "themeGrey",
            fontSize: {
              base: "10",
              lg: "12"
            },
            lineHeight: 4,
            fontWeight: 300,
            letterSpacing: -0.3
          };
        },
        joinWaitlist_Guests_Note_Wrapper: function joinWaitlist_Guests_Note_Wrapper() {
          return {
            maxW: 300,
            textAlign: "center",
            mx: "auto",
            px: 4,
            mb: 2
          };
        },
        joinWaitlist_Guests_PhoneNumber: function joinWaitlist_Guests_PhoneNumber() {
          return {
            fontSize: 10,
            lineHeight: 4,
            letterSpacing: -0.3,
            color: "#A1784D",
            flexDirection: "row",
            whiteSpace: "nowrap"
          };
        },
        joinWaitlist_CTA_Cancel_Button_Text: function joinWaitlist_CTA_Cancel_Button_Text() {
          return {
            fontSize: {
              base: "16",
              lg: "20"
            },
            color: "amenitiesActionButtonsColor",
            textTransform: "uppercase",
            _web: {
              textTransform: "capitalize"
            }
          };
        },
        joinWaitlist_CTA_JW_Button_Text: function joinWaitlist_CTA_JW_Button_Text() {
          return {
            fontSize: {
              base: "16px",
              lg: "20px"
            },
            color: "white",
            textTransform: "uppercase",
            _web: {
              textTransform: "capitalize"
            }
          };
        },
        joinWaitlist_EstTime_Title: function joinWaitlist_EstTime_Title() {
          return {
            color: "#494949",
            fontSize: 16,
            letterSpacing: -0.3,
            textAlign: "center"
          };
        },
        joinWaitlist_EstTime_Unvailable_Text: function joinWaitlist_EstTime_Unvailable_Text() {
          return {
            fontWeight: "300",
            color: "#303030",
            fontSize: {
              base: "14",
              lg: "16"
            },
            letterSpacing: -0.3,
            textAlign: "center",
            lineHeight: 5,
            maxW: {
              lg: 400
            }
          };
        },
        joinWaitlist_EstTime_NoWait_Text: function joinWaitlist_EstTime_NoWait_Text() {
          return {
            fontWeight: "300",
            color: "#303030",
            fontSize: {
              base: "14",
              lg: "16"
            },
            letterSpacing: -0.3,
            textAlign: "center",
            lineHeight: 5,
            maxW: {
              lg: 400
            }
          };
        },
        joinWaitlist_EstTime_Available_Text: function joinWaitlist_EstTime_Available_Text() {
          return {
            fontWeight: "300",
            color: "#303030",
            fontSize: {
              base: "14",
              lg: "16"
            },
            _ios: {
              fontSize: {
                base: "14"
              }
            },
            _android: {
              fontSize: {
                base: "14"
              }
            },
            letterSpacing: -0.3,
            textAlign: "center",
            lineHeight: 5,
            maxW: {
              lg: 400
            }
          };
        },
        joinWaitlist_EstTime_Available_Time: function joinWaitlist_EstTime_Available_Time() {
          return {
            color: "#303030",
            fontSize: 32,
            letterSpacing: -0.3,
            textAlign: "center",
            mb: 2
          };
        },
        joinWaitlist_WaitTimeInfo_Text: function joinWaitlist_WaitTimeInfo_Text() {
          return {
            color: "themeGrey",
            fontWeight: 300,
            fontSize: {
              base: "12",
              lg: "13"
            },
            lineHeight: 5,
            letterSpacing: -0.3
          };
        },
        joinWaitlist_Form_Error: function joinWaitlist_Form_Error() {
          return {
            color: "red.400",
            fontWeight: 400,
            fontSize: ["xs"],
            mt: 2
          };
        },
        joinWaitlist_Form_Mobile_Number_Info_Text: function joinWaitlist_Form_Mobile_Number_Info_Text() {
          return {
            color: "#7E7E7E",
            fontWeight: "400",
            fontSize: {
              base: 11,
              lg: 12
            },
            mt: {
              base: "6px",
              lg: 2
            }
          };
        },
        joinWaitlist_Form_Title: function joinWaitlist_Form_Title() {
          return {
            fontSize: {
              base: 16,
              lg: 24
            },
            fontFamily: "Bebas-New"
          };
        },
        joinWaitlist_Form_Checkbox: function joinWaitlist_Form_Checkbox() {
          return {
            color: "#606060",
            fontSize: 14,
            lineHeight: 4,
            fontWeight: 300,
            ml: 2,
            mr: 2.5,
            _web: {
              userSelect: "none"
            },
            flexShrink: 1
          };
        },
        joinWaitlist_Form_Filled_Status: function joinWaitlist_Form_Filled_Status() {
          return {
            fontSize: 12,
            color: "#993324"
          };
        },
        joinWaitlist_Form_Filled_PhoneNumber: function joinWaitlist_Form_Filled_PhoneNumber() {
          return {
            fontSize: 14,
            fontWeight: 300
          };
        },
        joinWaitlist_Form_Filled_Email: function joinWaitlist_Form_Filled_Email() {
          return {
            fontSize: 14,
            fontWeight: 300,
            mb: 2
          };
        },
        joinWaitlist_Form_Filled_Name: function joinWaitlist_Form_Filled_Name() {
          return {
            fontSize: 14,
            mb: 2
          };
        },
        joinWaitlist_WineWhileYouWait_Msg: function joinWaitlist_WineWhileYouWait_Msg() {
          return {
            fontWeight: "300",
            fontSize: {
              base: "sm",
              lg: "lg"
            },
            lineHeight: 5,
            maxWidth: "65%",
            flexWrap: "wrap",
            letterSpacing: -0.4,
            flex: 1,
            ml: {
              lg: 8
            },
            color: "#54301A"
          };
        },
        joinWaitlist_Header_Logout: function joinWaitlist_Header_Logout() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#54301A"
          };
        },
        joinWaitlist_Header_MyAcc: function joinWaitlist_Header_MyAcc() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#54301A"
          };
        },
        joinWaitlist_Header_MyAcc_Mobile: function joinWaitlist_Header_MyAcc_Mobile() {
          return {
            fontSize: 8,
            mt: 1,
            color: "#A2402A"
          };
        },
        joinWaitlist_Header_Title: function joinWaitlist_Header_Title() {
          return {
            fontWeight: 400,
            fontSize: 20,
            color: "#303030",
            letterSpacing: -0.3
          };
        },
        // JOIN WAITLIST END
        refreshErrorWaitlist: {
          fontSize: 16
        },
        waitlistRestaurantInfoBoxTitle: {
          fontSize: 15,
          fontWeight: 400,
          color: "waitlistRestaurantInfoBoxText"
        },
        waitlistRestaurantInfoBoxBody: {
          lineHeight: 18,
          fontSize: 14,
          fontWeight: 200,
          color: "waitlistRestaurantInfoBoxText"
        },
        leaveTheLineLinkText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16,
          color: "#A1784D"
        },
        remoteCheckinNoteText: {
          _android: {
            lineHeight: 5
          },
          _ios: {
            lineHeight: 5
          },
          mt: 3,
          _web: {
            fontSize: "14px"
          },
          fontSize: "sm",
          fontWeight: 300,
          textAlign: "center"
        },
        //JWC STARTS
        jwcLeaveTheLineCancelBtn: {
          fontSize: 16,
          fontWeight: 400,
          color: "primary.100"
        },
        jwcLeaveTheLineContinueBtn: {
          fontSize: 16,
          fontWeight: 400
        },
        jwcLeaveTheLineModalTitle: {
          fontSize: 16,
          color: "#303030",
          fontFamily: "headingSecondary",
          textTransform: "uppercase"
        },
        jwcLeaveTheLineModalBody: {
          fontWeight: 300,
          fontSize: {
            base: 18,
            lg: 14
          },
          lineHeight: {
            base: 25,
            lg: 18
          },
          color: {
            base: "#606060",
            lg: "#020001"
          }
        },
        jwcEstWaitTimePrefix: {
          textAlign: "center",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 6,
          color: "#54301A"
        },
        jwcEstWaitTime: {
          lineHeight: 10,
          fontWeight: 400,
          textAlign: "center",
          fontSize: 32,
          color: "#54301A"
        },
        jwcRestDetails: {
          color: "#80603D",
          lineHeight: 4,
          fontSize: 12,
          fontWeight: 300
        },
        jwcRestName: {
          color: "#80603D",
          fontSize: 15,
          fontWeight: 400
        },
        jwcHowItWorksText: {
          fontSize: 14,
          fontWeight: 300,
          color: {
            base: "#A1784D",
            lg: "white"
          },
          textAlign: "center"
        },
        jwcOrderWhileYouWaitText: {
          textAlign: "center",
          color: {
            base: "white",
            lg: "#A1784D"
          },
          fontSize: 16,
          fontWeight: 400
        },
        qualityStoryCtaText: {
          textAlign: "center",
          color: {
            base: "#A1784D",
            lg: "#A1784D"
          },
          fontSize: 16,
          fontWeight: 400
        },
        jwcOrderAheadText: {
          fontSize: {
            base: 22,
            lg: 40
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 48,
          textAlign: "center",
          fontFamily: "Bebas-New"
        },
        qualityStoryDescText: {
          fontSize: {
            base: 21,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        jwcHeaderDirectionsText: {
          color: "#A1784D",
          fontSize: 14
        },
        jwcHeaderLocationName: {
          color: "#303030",
          fontSize: 16,
          fontWeight: 300
        },
        jwcViewPdfMenu: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcLeaveTheLine: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcWaitTimeVary: {
          textAlign: "center",
          fontWeight: 300,
          fontSize: 18,
          color: " #2A2C25",
          lineHeight: 24
        },
        jwcWaitTimeVaryMobile: {
          fontSize: 14,
          fontWeight: "400",
          lineHeight: 4
        },
        jwcPartySizeNumber: {
          fontWeight: 400,
          fontSize: 17,
          color: "#494949"
        },
        jwcPartySize: {
          fontWeight: 300,
          fontSize: 17,
          color: "#494949"
        },
        jwcTitle: {
          textAlign: "center",
          mt: 6,
          fontSize: 24,
          fontWeight: 600,
          color: "#020001"
        },
        jwcTitleText: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 600,
          color: "#020001",
          mb: 4,
          mx: 1,
          lineHeight: 7,
          _ios: {
            mx: 2
          },
          _android: {
            mx: 2
          }
        },
        waitListFooterText: {
          marginTop: 2,
          fontSize: 14,
          fontWeight: 300,
          maxWidth: 74,
          textAlign: "center"
        },
        fwlvButtonText: {
          fontSize: 14,
          color: "#A1784D",
          textAlign: "center",
          marginTop: 2,
          textTransform: "capitalize"
        },
        refreshIconText: {
          textTransform: "uppercase",
          fontSize: 12,
          color: "#A1784D",
          lineHeight: 14
        },
        waitlistCheckbackSoonTitle: {
          color: "#4E311F",
          fontWeight: 400,
          fontSize: 20,
          lineHeight: 20
        },
        waitlistCheckbackSoonBody: {
          color: "#606060",
          pt: 4,
          fontWeight: 200,
          fontSize: 16,
          lineHeight: 20
        },
        checkinSuccessNoteTitleText: {
          color: "#FFFFFF",
          pt: 3,
          fontSize: {
            base: 20,
            md: 22
          },
          lineHeight: 22,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        checkinSuccessNoteBodyText: {
          color: "#FFFFFF",
          pt: 3,
          px: 4,
          textAlign: "center",
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        leaveTheLineText: {
          fontWeight: 200,
          color: "#303030",
          fontSize: 14,
          lineHeight: 16
        },
        leaveWaitlistErrorModal: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 25,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060"
        },
        waitlistErrorTitle: {
          fontWeight: 600,
          fontSize: 24,
          lineHeight: 24,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#020001"
        },
        waitlistErrorBody: {
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 28,
          color: "#606060",
          mt: 2,
          textAlign: "center",
          maxWidth: 253
        },
        waitTimeText: {
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 16,
          mb: 2
        },
        waitTimeMins: {
          fontWeight: 400,
          fontSize: 32,
          lineHeight: 36
        },
        remoteCheckinTitle: {
          color: "#4E311F",
          fontSize: 24,
          fontWeight: 600,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3",
          textAlign: "center"
        },
        howItWorksStepsNumber: {
          fontWeight: 500,
          color: "#2C2A26",
          fontSize: 14
        },
        remoteCheckinWaitTimeThankYou: {
          color: "#020001",
          fontSize: 24,
          fontWeight: 600,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3"
        },
        remoteCheckinWaitTimePartySizePrefix: {
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 14
        },
        remoteCheckinWaitTimePartySize: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 14
        },
        remoteCheckinWaitTimeNote: {
          fontSize: 14,
          fontWeight: 100,
          lineHeight: 4
        },
        remoteCheckinBodyOrderAheadText: {
          fontFamily: "Bebas-New",
          fontSize: 26,
          fontWeight: 600,
          color: "white",
          maxWidth: 227
        },
        enableLocationText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 15,
          textAlign: "center",
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          color: "#452D20"
        },
        checkinSuccessModalHeaderText: {
          fontFamily: "body",
          fontWeight: 400,
          fontSize: 15,
          textAlign: "center",
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          color: "#452D20"
        },
        checkinSuccessModalBodyText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 12,
          px: 5,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          lineHeight: 17,
          color: "#303030"
        },
        checkinErrorModalHeaderText: {
          fontFamily: "body",
          fontWeight: 400,
          fontSize: 18,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          lineHeight: 6,
          color: "#452D20"
        },
        clearedWaitlistBodyText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 16,
          px: 7,
          lineHeight: 22,
          color: "#020001"
        },
        clearedWaitlistHeaderText: {
          fontFamily: "body",
          fontWeight: 400,
          fontSize: 24,
          lineHeight: 27,
          color: "#452D20",
          maxW: 275
        },
        noCheckHeaderText: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 22,
          lineHeight: 26,
          color: "#303030"
        },
        waitlistBannerHeaderText: {
          fontSize: 15,
          fontWeight: 500,
          color: "white"
        },
        checkinErrorModalBodyText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 15,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          lineHeight: 5,
          color: "#303030"
        },
        remoteCheckinBodyText: {
          fontSize: 16,
          fontWeight: 400,
          color: "white"
        },
        remoteCheckinRefreshBtn: {
          color: "remoteCheckinRefreshBtnColor",
          fontSize: 12,
          fontWeight: 300,
          marginY: 11,
          marginTop: 13,
          marginX: 5
        },
        confirmAndAddToCart: {
          textTransform: "uppercase",
          color: "white",
          fontWeight: 600
        },
        startingAtPrice: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        startingAtText: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        categoryText: function categoryText(_ref22) {
          var isActive = _ref22.isActive;
          return {
            fontSize: {
              base: "sm",
              md: "sm"
            },
            fontWeight: isActive ? "600" : "400"
          };
        },
        noThanksText: {
          fontFamily: "headingSecondary",
          fontSize: "3xl",
          textDecoration: "underline",
          textDecorationColor: "white",
          textAlign: "center",
          color: "white",
          _web: {
            fontSize: "24px",
            mt: 5
          },
          _ios: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          },
          _android: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          }
        },
        youMayLikeText: {
          fontFamily: "headingSecondary",
          fontSize: "3xl"
        },
        orderTypeText: {
          fontSize: "sm",
          fontWeight: "300"
        },
        nutritinalInfo: {
          _web: {
            fontSize: "18px"
          },
          fontWeight: 400
        },
        globalBannerCareer: function globalBannerCareer() {
          return {
            textTransform: "uppercase",
            fontWeight: 100,
            color: "#fff",
            fontSize: {
              base: "10px",
              md: "10px",
              lg: "13px"
            },
            right: 0
          };
        },
        menuItemNameWeight: function menuItemNameWeight(_ref23) {
          var isFromSmartRecsOrFrequentlyOrdered = _ref23.isFromSmartRecsOrFrequentlyOrdered;
          return {
            fontWeight: 600,
            fontSize: [14, 14, 14, isFromSmartRecsOrFrequentlyOrdered ? 14 : 20]
          };
        },
        listDescriptionText: function listDescriptionText() {
          return {
            _web: {
              fontSize: 14,
              fontWeight: 300,
              fontFamily: "heading"
            }
          };
        },
        categoryFontSize: function categoryFontSize() {
          return {
            fontSize: ["xl", "xl", "48"],
            fontWeight: 600,
            fontFamily: "headingSecondary"
          };
        },
        subCategoryFontSize: function subCategoryFontSize() {
          return {
            // mocks needs for values
            fontSize: [16, 16, 40],
            fontFamily: "headingSecondary",
            fontWeight: 400
          };
        },
        subSubCategoryFontSize: function subSubCategoryFontSize() {
          return {
            fontSize: ["md", "md", "32"]
          };
        },
        locationText: {
          color: "primary.100",
          fontSize: "14px",
          fontFamily: "headerFont"
        },
        phoneNumberText: {
          color: "#544940",
          fontSize: "xs",
          fontFamily: "headerFont",
          fontWeight: "300"
        },
        btnText: {
          color: "primary.100",
          fontFamily: "headerFont",
          _web: {
            fontSize: "14px"
          }
        },
        headerText: {
          color: "primary.100"
        },
        cartItemCancelText: {
          fontSize: 13,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "secondary.300",
          fontWeight: 500
        },
        checkoutText: {
          fontSize: "xl",
          lineHeight: 6,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase"
        },
        addMoreItemsText: {
          fontSize: "md",
          fontWeight: 400,
          lineHeight: 5,
          textTransform: "uppercase",
          color: "secondary.300"
        },
        checkoutPriceText: {
          fontSize: "md",
          lineHeight: 5,
          fontWeight: 400,
          color: "white"
        },
        menuItemInfoName: function menuItemInfoName() {
          return {
            _web: {
              mb: {
                base: "6px",
                md: "8px"
              }
            },
            mb: {
              base: 1,
              md: 2
            },
            fontSize: ["2xl", "2xl", "4xl"],
            fontFamily: "headingSecondary",
            fontWeight: 600
          };
        },
        addToCardButtonPriceText: function addToCardButtonPriceText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "18px",
                md: "32px"
              }
            },
            fontWeight: 400,
            fontFamily: "headingSecondary",
            _ios: {
              fontSize: 18
            },
            _android: {
              fontSize: 18
            }
          };
        },
        addToCardButtonText: function addToCardButtonText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "18px",
                md: "32px"
              }
            },
            fontWeight: 400,
            fontFamily: "headingSecondary",
            _ios: {
              fontSize: 18
            },
            _android: {
              fontSize: 18
            }
          };
        },
        menuItemDetailsPropertyAccordionHeading: function menuItemDetailsPropertyAccordionHeading(_ref24) {
          var isMandatory = _ref24.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "16px",
                md: "24px"
              },
              letterSpacing: "-0.3px"
            },
            _android: {
              letterSpacing: 1
            },
            _ios: {
              letterSpacing: 1
            },
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 500,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "heading",
            textTransform: "capitalize"
          };
        },
        skuMenuItemDetailsPropertyAccordionHeading: function skuMenuItemDetailsPropertyAccordionHeading(_ref25) {
          var isMandatory = _ref25.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "16px",
                md: "24px"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 500,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "heading",
            textTransform: "capitalize"
          };
        },
        menuItemDetailsQuestionVarient: function menuItemDetailsQuestionVarient(_ref26) {
          var isMobile = _ref26.isMobile;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "md"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 5
            },
            fontWeight: {
              base: 300,
              md: 500
            },
            color: "themeTextColor",
            textTransform: isMobile && "uppercase",
            fontFamily: isMobile ? "headingSecondary" : "body"
          };
        },
        menuItemDetailsIsRequiredMark: function menuItemDetailsIsRequiredMark(_ref27) {
          var isMandatory = _ref27.isMandatory;
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            _web: {
              letterSpacing: "-0.3px",
              mt: "5px"
            },
            letterSpacing: "-0.3",
            fontWeight: 300,
            color: "white",
            lineHeight: {
              base: 4,
              md: 5
            },
            alignSelf: "center"
          };
        },
        menuItemDetailsPropertyAccordionRightText: function menuItemDetailsPropertyAccordionRightText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            lineHeight: 5,
            color: "white",
            _web: {
              letterSpacing: "-0.3 px"
            },
            letterSpacing: "-0.3"
          };
        },
        menuDetailPropertyAccordionDescription: function menuDetailPropertyAccordionDescription(_ref28) {
          var isMandatory = _ref28.isMandatory,
              isDefaultExpanded = _ref28.isDefaultExpanded;
          return {
            fontFamily: "body",
            fontSize: {
              base: "xs",
              md: "md"
            },
            lineHeight: {
              base: 4,
              md: 5
            },
            fontWeight: 200,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            color: isDefaultExpanded ? "white" : "themeTextColor"
          };
        },
        menuDetailErrorText: function menuDetailErrorText() {
          return {
            fontSize: "xs",
            color: "#CD3838",
            fontWeight: 400,
            lineHeight: 4
          };
        },
        deliveryErrorText: function deliveryErrorText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            color: "#CD3838",
            fontWeight: 300,
            lineHeight: 4
          };
        },
        confirmPickupDetailsHeaderText: function confirmPickupDetailsHeaderText() {
          return {
            textTransform: "uppercase",
            fontFamily: "headingSecondary",
            fontSize: 22,
            fontWeight: 700,
            color: "#A1784D",
            lineHeight: 6
          };
        },
        confirmPickupDetailsRestaurant: function confirmPickupDetailsRestaurant() {
          return {
            fontFamily: "heading",
            fontSize: 16,
            lineHeight: 5,
            fontWeight: 600
          };
        },
        confirmPickupDetailsText: function confirmPickupDetailsText() {
          return {
            color: "orderConfirmationTextColor",
            fontWeight: 400,
            lineHeight: 4,
            fontSize: 14,
            _web: {
              letterSpacing: "2px"
            },
            letterSpacing: 1
          };
        },
        mobilePayHeaderBtnText: function mobilePayHeaderBtnText() {
          return {
            fontSize: {
              base: 14,
              md: 18
            },
            fontWeight: 400,
            color: "secondary.300"
          };
        },
        confirmPickupDetailsChangeBtnText: function confirmPickupDetailsChangeBtnText() {
          return {
            fontSize: 13,
            fontWeight: 600,
            color: "orderConfirmationTextColor"
          };
        },
        cartItemMenuName: function cartItemMenuName(_ref29) {
          var inOrderDetails = _ref29.inOrderDetails;
          return {
            fontSize: 17,
            lineHeight: 5,
            _web: {
              letterSpacing: !inOrderDetails ? "-0.3px" : "0.2px",
              width: {
                base: inOrderDetails ? "100%" : "164px"
              }
            },
            letterSpacing: "-0.3",
            width: {
              base: 40
            },
            fontWeight: 600,
            color: "menuItemNameColor",
            fontFamily: !inOrderDetails ? "heading" : "headingSecondary"
          };
        },
        cartItemPrice: function cartItemPrice() {
          return {
            fontSize: "sm"
          };
        },
        cartMessageText: function cartMessageText() {
          return {
            fontWeight: 300,
            fontSize: "xs"
          };
        },
        checkoutNoOfItems: function checkoutNoOfItems() {
          return {
            fontSize: "xxs"
          };
        },
        cartItemMenuPropertyName: function cartItemMenuPropertyName() {
          return {
            fontSize: 15,
            lineHeight: 5,
            fontWeight: 400,
            _web: {
              letterSpacing: "-0.3px",
              width: "176px"
            },
            letterSpacing: "-0.3",
            width: 40,
            noOfLines: 3,
            color: "menuItemNameColor"
          };
        },
        orderSettingsText: function orderSettingsText() {
          return {
            fontWeight: "400",
            fontSize: "sm"
          };
        },
        menuItemInfoPrice: function menuItemInfoPrice() {
          return {
            fontFamily: "heading",
            fontWeight: 400,
            _web: {
              fontSize: {
                base: "14px",
                md: "18px"
              }
            } // fontSize: { base: 3, md: 4 },

          };
        },
        menuItemInfoPriceStartingAt: function menuItemInfoPriceStartingAt() {
          return {
            _web: {
              fontSize: {
                base: "13px",
                md: "18px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: "300"
          };
        },
        menuItemInfoCalorie: function menuItemInfoCalorie() {
          return {
            _web: {
              fontSize: {
                base: "13px",
                md: "16px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: "300"
          };
        },
        skuSelectorItemPriceText: function skuSelectorItemPriceText() {
          return {
            fontWeight: 500,
            fontSize: {
              base: 14,
              md: 14
            }
          };
        },
        skuSelectorItemName: function skuSelectorItemName() {
          return {
            fontWeight: 300,
            fontSize: {
              base: 14,
              md: 18
            }
          };
        },
        mobileAuthHeaderText: function mobileAuthHeaderText() {
          return {
            fontWeight: 300,
            fontSize: 24,
            color: "#505050"
          };
        },
        menuItemPrice: function menuItemPrice() {
          return {
            fontSize: [12, 12, 14],
            fontWeight: 500,
            pr: 1
          };
        },
        temperatureSelectLabel: function temperatureSelectLabel() {
          return {
            color: "#020001",
            fontSize: "lg",
            fontFamily: "headingSecondary"
          };
        },
        cartHeaderOrderType: function cartHeaderOrderType() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 300,
            color: "cartHeaderOrderType",
            textDecoration: "underline",
            textDecorationColor: "cartHeaderOrderType"
          };
        },
        cartHeaderLocationName: function cartHeaderLocationName() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            color: "cartHeaderLocationName",
            textDecoration: "underline",
            textDecorationColor: "cartHeaderLocationName"
          };
        },
        emptyCartText: {
          fontSize: "sm",
          fontWeight: 300,
          lineHeight: 4
        },
        allLocationsSelectHeading: {
          fontSize: 28,
          fontWeight: 600
        },
        allLocationsSelectText: {
          fontSize: 20,
          fontWeight: 600,
          color: "#2A2C25"
        },
        allLocationsText: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600
        },
        allLocationsLengthText: {
          fontSize: 16,
          color: "#606060",
          fontWeight: 300
        },
        addBtnText: function addBtnText(_ref30) {
          var addButtonText = _ref30.addButtonText;
          return {
            color: "white",
            textTransform: "uppercase",
            fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 10 : "md",
            overflowWrap: "break-word",
            maxWidth: {
              base: "70px",
              md: "110px"
            },
            textAlign: "center",
            marginBottom: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "2px" : 0,
            _ios: {
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            },
            _android: {
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            }
          };
        },
        menuListTextCTA: {
          fontWeight: 400,
          fontSize: [10, 10, 14, 14, 14]
        },
        menuItemCalorieText: {
          fontSize: [12, 12, 14],
          fontWeight: 200,
          pl: 1
        },
        cartItemRemoveText: {
          fontSize: 13,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "white",
          fontWeight: 500
        },
        reorderAddButtonText: {
          fontSize: 18,
          fontWeight: 500,
          color: "reOrderAddBtnBorder"
        },
        pdfMenuButtonText: {
          mt: 1,
          _web: {
            mt: 0
          }
        },
        locationListRestaurantName: {
          fontWeight: 400,
          fontSize: "sm",
          lineHeight: 14,
          textAlign: "left"
        },
        locationListRestaurantDetails: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          _web: {
            width: "70%",
            lineHeight: "18px"
          },
          fontWeight: 300,
          lineHeight: 14
        },
        locationListResturantAddressSecondLine: {
          marginTop: 1,
          marginBottom: 0.5
        },
        confirmationSurveyHeader: function confirmationSurveyHeader() {
          return {
            color: "#020001",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationSurveyText: function confirmationSurveyText() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        // @ts-ignore
        confirmationEclubHeader: function confirmationEclubHeader() {
          return {
            color: "#020001",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationEclubEmail: function confirmationEclubEmail() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationEclubChangeEmail: function confirmationEclubChangeEmail() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationEclubCheckboxText: function confirmationEclubCheckboxText() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationAccountHeader: function confirmationAccountHeader() {
          return {
            color: "#020001",
            fontSize: {
              base: 16,
              lg: 20
            },
            fontWeight: "400"
          };
        },
        confirmationAccountEmail: function confirmationAccountEmail() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationPickupMyOrderHeader: function confirmationPickupMyOrderHeader() {
          return {
            color: "#020001",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsHeader: function confirmationPickupDetailsHeader() {
          return {
            color: "#020001",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsSubTitle: function confirmationPickupDetailsSubTitle() {
          return {
            color: "confirmationAccentDark",
            fontSize: {
              base: 12,
              lg: 13
            }
          };
        },
        confirmationThankYouTitle: function confirmationThankYouTitle() {
          return {
            color: "#4E311D",
            fontSize: {
              base: 18,
              lg: 32
            },
            fontWeight: {
              base: "400",
              lg: "600"
            }
          };
        },
        confirmationThankYouMailText: function confirmationThankYouMailText() {
          return {
            color: "confirmationAccentDark",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "300"
          };
        },
        confirmationThankYouMail: function confirmationThankYouMail() {
          return {
            color: "#80603D",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "600"
          };
        },
        confirmationThankYouDetailTitle: function confirmationThankYouDetailTitle() {
          return {
            color: "#494949",
            fontSize: {
              base: 14
            },
            fontFamily: "heading"
          };
        },
        confirmationOrderNumber: function confirmationOrderNumber() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "#494949",
            fontWeight: "400"
          };
        },
        confirmationHowToText: function confirmationHowToText() {
          return {
            fontSize: {
              base: 12,
              lg: 14
            },
            color: "#494949"
          };
        },
        confirmationMarketingTitle: function confirmationMarketingTitle() {
          return {
            color: "#020001",
            fontWeight: 400,
            fontSize: {
              base: 12,
              lg: 14
            }
          };
        },
        confirmationMarketingSubtitle: function confirmationMarketingSubtitle() {
          return {
            color: "confirmationAccent",
            fontWeight: "300",
            fontSize: 12
          };
        },
        confirmationPickupRestName: function confirmationPickupRestName() {
          return {
            fontFamily: "headingSecondary",
            fontSize: {
              base: 12,
              lg: 16
            },
            lineHeight: 3
          };
        },
        confirmationPickupResAdd1: {
          lineHeight: 4,
          marginBottom: 1
        },
        confirmationPickupResAdd2: {
          lineHeight: 4
        },
        confirmationOrderTotalItem: function confirmationOrderTotalItem() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationOrderTotal: function confirmationOrderTotal() {
          return {
            fontSize: {
              base: 18,
              lg: 23
            }
          };
        },
        confirmationPaymentDetailsTitle: function confirmationPaymentDetailsTitle() {
          return {
            color: "black",
            fontSize: {
              base: 16,
              lg: 18
            }
          };
        },
        confirmationSpecialInstructionTitle: function confirmationSpecialInstructionTitle() {
          return {
            fontSize: {
              base: 12,
              md: 18
            },
            color: "#020001"
          };
        },
        confirmationSpecialInstructionSubTitle: function confirmationSpecialInstructionSubTitle() {
          return {
            fontSize: {
              base: 12,
              md: 16
            }
          };
        },
        confirmationCardChargeInfo: function confirmationCardChargeInfo() {
          return {
            fontSize: {
              base: 12,
              lg: 16
            }
          };
        },
        confirmationChangesHeader: function confirmationChangesHeader() {
          return {
            color: "#020001",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        //OC AddressAndTime variants start
        confirmationPickupRestaurantTitle: function confirmationPickupRestaurantTitle() {
          return {
            fontWeight: "500"
          };
        },
        confirmationPickupDateTimeTitle: function confirmationPickupDateTimeTitle() {
          return {
            fontWeight: "500",
            _ios: {
              py: 1
            },
            _android: {
              py: 1
            },
            marginBottom: 1.5
          };
        },
        confirmationDeliveryAddressTitle: function confirmationDeliveryAddressTitle() {
          return {
            fontWeight: "500"
          };
        },
        confirmationDeliveryRestaurantTitle: function confirmationDeliveryRestaurantTitle() {
          return {
            fontWeight: "500"
          };
        },
        confirmationDeliveryDateTimeTitle: function confirmationDeliveryDateTimeTitle() {
          return {
            fontWeight: "500"
          };
        },
        confirmationDeliveryGuestsTitle: function confirmationDeliveryGuestsTitle() {
          return {
            fontWeight: "500"
          };
        },
        //OC AddressAndTime variants end
        orderTrackingCallHelpText: {
          fontSize: "sm",
          fontWeight: 400,
          lineHeight: 5
        },
        orderStatusTrackingTitle: function orderStatusTrackingTitle() {
          return {
            color: "#80603D",
            fontWeight: 400,
            fontSize: "xl",
            lineHeight: 6
          };
        },
        orderStatusTitle: function orderStatusTitle() {
          return {
            fontSize: "sm",
            fontWeight: 400,
            lineHeight: 6,
            color: "orderStatusText"
          };
        },
        orderStatusSubText: function orderStatusSubText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusTime: function orderStatusTime() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusPayNowButtonText: function orderStatusPayNowButtonText() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 500,
            color: "white"
          };
        },
        orderStatusCurbsideCheckInButtonPrimary: function orderStatusCurbsideCheckInButtonPrimary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInPrimary"
          };
        },
        orderStatusCurbsideCheckInButtonSecondary: function orderStatusCurbsideCheckInButtonSecondary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInSecondary"
          };
        },
        orderStatusDeatilsTitle: function orderStatusDeatilsTitle() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "#4D2C42",
            marginBottom: 3.5
          };
        },
        otCurbsideVehicleDetailsTitle: function otCurbsideVehicleDetailsTitle() {
          return {
            fontSize: "xs",
            lineHeight: 3,
            fontWeight: 300,
            color: "#606060",
            marginBottom: 1
          };
        },
        otCurbsideVehicleDetails: function otCurbsideVehicleDetails() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            textTransform: "capitalize"
          };
        },
        refreshButtonText: function refreshButtonText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        autoRefreshText: function autoRefreshText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        orderTrackingLocationTimeSectionText: {
          ml: 2,
          fontSize: "sm",
          lineHeight: 6,
          fontWeight: 400
        },
        waitlistLocationName: {
          fontSize: 14,
          fontWeight: 300,
          color: "#303030"
        },
        waitlistLocationShare: {
          fontSize: 12,
          fontWeight: 400,
          color: "#A1784D",
          textTransform: "uppercase"
        },
        waitlistBannerText: {
          fontSize: 14,
          fontWeight: 200,
          color: "white",
          lineHeight: 18
        },
        waitlistTableHeaderText: {
          fontSize: {
            base: 12,
            md: 12,
            lg: 14
          },
          color: "#303030",
          fontWeight: 500,
          py: 4,
          textAlign: "center"
        },
        waitlistTableText: {
          fontSize: {
            base: 16,
            md: 16,
            lg: 18
          },
          color: "#303030",
          fontWeight: 300,
          py: 4,
          textAlign: "center"
        },
        waitlistTableNotUserName: {
          fontSize: 18,
          color: "#303030",
          fontWeight: 300,
          my: 4,
          textAlign: "center",
          letterSpacing: 1
        },
        refreshWaitlist: {
          fontWeight: 300
        },
        waitlistDisclaimer: {
          fontWeight: 300
        },
        waitlistOrder: {
          color: "#A1784D",
          textTransform: "uppercase",
          fontWeight: 400,
          fontSize: 12
        },
        waitlistFooterHowItWorks: {
          fontWeight: 400,
          color: "secondary.300",
          fontSize: 14
        },
        orderStatusTimeMessage: function orderStatusTimeMessage() {
          return {
            marginTop: 2,
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        howItWorksSteps: {
          fontWeight: 300,
          color: "#2C2A26",
          fontSize: 14
        },
        howItWorksActionButton: {
          fontWeight: 400,
          fontSize: 16
        },
        howItWorksHeader: {
          fontSize: 14,
          fontWeight: 600
        },
        howItWorksBanner: {
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 14
        },
        checkText: function checkText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            color: "checkText"
          };
        },
        checkAmount: function checkAmount() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "checkText"
          };
        },
        curbsideCheckInAvailableText: function curbsideCheckInAvailableText() {
          return {
            fontSize: "sm",
            lineHeight: 5,
            fontWeight: 300,
            textAlign: "center",
            color: "curbsideCheckInAvailable"
          };
        },
        sectionHeaderText: function sectionHeaderText() {
          return {
            color: "themeTextColor",
            fontWeight: 400
          };
        },
        subSectionHeaderText: function subSectionHeaderText() {
          return {
            color: "themeTextColor",
            fontWeight: 400
          };
        },
        notificationsPopupText: function notificationsPopupText() {
          return {
            color: "menuItemNameColor",
            fontWeight: 400
          };
        },

        /* Restaurant Details Start */
        //Restaurant Info
        restaurantDetails_RestInfo_AddToFavoritesText: function restaurantDetails_RestInfo_AddToFavoritesText() {
          return {
            alignItems: "center",
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            ml: "6px",
            h: "20px",
            //font specific styles
            pt: "2px"
          };
        },
        restaurantDetails_RestInfo_TitleText: function restaurantDetails_RestInfo_TitleText() {
          return {
            fontWeight: "600",
            color: {
              base: "#4E311F",
              lg: "restDetailsRestInfoTitleColor"
            },
            mb: {
              base: "2",
              lg: "0"
            },
            fontSize: {
              base: "20px",
              lg: "32px"
            },
            textAlign: {
              base: "center",
              lg: "normal"
            },
            fontFamily: "Bebas-New"
          };
        },
        restaurantDetails_RestInfo_OpensText: function restaurantDetails_RestInfo_OpensText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor"
          };
        },
        restaurantDetails_RestInfo_DateText: function restaurantDetails_RestInfo_DateText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor",
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestInfo_AddressText: function restaurantDetails_RestInfo_AddressText() {
          return {
            fontWeight: 400,
            lineHeight: 6,
            px: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            _web: {
              lineHeight: 6,
              my: 4,
              px: 0,
              ml: 3
            },
            textAlign: {
              base: "center",
              lg: "flex-start"
            },
            w: "100%",
            _ios: {
              flex: 1
            },
            _android: {
              flex: 1
            },
            textDecoration: "underline",
            textDecorationColor: "restaurantInfoAddressTextColor",
            color: "#A1784D"
          };
        },
        restaurantDetails_RestInfo_PhoneNumberText: function restaurantDetails_RestInfo_PhoneNumberText(_ref31) {
          var customMarginHorizontal = _ref31.customMarginHorizontal;
          return {
            _ios: {
              mx: customMarginHorizontal || 0
            },
            _android: {
              mx: customMarginHorizontal || 0
            },
            fontWeight: "200",
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "#A1784D"
          };
        },
        restaurantDetails_RestInfo_DistanceText: function restaurantDetails_RestInfo_DistanceText() {
          return {
            fontWeight: "300",
            fontSize: "14px",
            color: "restaurantInfoNumberAndDistanceTextColor"
          };
        },
        restaurantDetails_RestInfo_GetDirectionsText: function restaurantDetails_RestInfo_GetDirectionsText() {
          return {
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            }
          };
        },
        //Restaurant Waitlist
        restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText: function restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText() {
          return {
            mb: "6",
            fontSize: [16],
            fontWeight: 300,
            px: 6,
            maxW: {
              lg: "350",
              xl: "400"
            },
            textAlign: "center",
            mx: "auto",
            color: "#606060"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName: function restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName() {
          return {
            color: "#782434"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize: function restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize() {
          return {
            fontWeight: "300",
            fontSize: 14,
            color: "#55111E"
          };
        },
        //Restaurant CurrentStatus and Waitlist
        restaurantDetails_RestWaitlist_CurrentStatusText: function restaurantDetails_RestWaitlist_CurrentStatusText() {
          return {
            fontWeight: "300",
            color: "#606060",
            fontSize: {
              base: "14",
              lg: "16"
            }
          };
        },
        restaurantDetails_RestWaitlist_AvailabilityText: function restaurantDetails_RestWaitlist_AvailabilityText() {
          return {
            _ios: {
              marginLeft: 4
            },
            _android: {
              marginLeft: 4
            },
            fontSize: "14px",
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            maxWidth: {
              base: 40,
              lg: "none"
            },
            lineHeight: 6
          };
        },
        restaurantDetails_RestWaitlist_JoinWaitlistText: function restaurantDetails_RestWaitlist_JoinWaitlistText(_ref32) {
          var disabled = _ref32.disabled;
          return {
            color: disabled ? "#BCBCBC" : "white",
            fontSize: "16px",
            fontWeight: "400",
            _android: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _ios: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _web: {
              py: 2.5,
              px: 2
            }
          };
        },
        restaurantDetails_RestWaitlist_EstWaitTimeText: function restaurantDetails_RestWaitlist_EstWaitTimeText() {
          return {
            _android: {
              marginTop: 2.5
            },
            _ios: {
              marginTop: 2.5
            },
            lineHeight: 3,
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            fontSize: "11",
            textAlign: "center",
            maxWidth: 40,
            _web: {
              maxWidth: 32,
              fontSize: "12px",
              marginTop: {
                base: 2,
                lg: 0
              }
            }
          };
        },
        //Restaurant Timings
        restaurantDetails_RestTimings_TitleText: function restaurantDetails_RestTimings_TitleText() {
          return {
            fontSize: {
              base: 18,
              lg: 24
            },
            // mb: 4,
            color: "#020001",
            fontFamily: "Bebas-New"
          };
        },
        restaurantDetails_RestTimings_SpecialDayTitleText: function restaurantDetails_RestTimings_SpecialDayTitleText() {
          return {
            marginBottom: 3,
            color: "restaurantSpecialDayHeadingTextColor",
            fontSize: "16px",
            textAlign: "center",
            px: "3"
          };
        },
        restaurantDetails_RestTimings_SpecialDayDescText: function restaurantDetails_RestTimings_SpecialDayDescText() {
          return {
            fontSize: "14px",
            fontWeight: "300",
            lineHeight: 20,
            color: "restaurantSpecialDayBodyTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconText: function restaurantDetails_RestTimings_WeekDayIconText() {
          return {
            lineHeight: 5,
            fontSize: "12px",
            textTransform: "capitalize",
            _ios: {
              paddingTop: 0.5,
              paddingLeft: 0.5
            }
          };
        },
        restaurantDetails_RestTimings_FullDayTitleText: function restaurantDetails_RestTimings_FullDayTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            textTransform: "capitalize",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursTitleText: function restaurantDetails_RestTimings_HoursTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_FullDayItemText: function restaurantDetails_RestTimings_FullDayItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            maxWidth: "50%",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursItemText: function restaurantDetails_RestTimings_HoursItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_MessageText: function restaurantDetails_RestTimings_MessageText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "13",
              lg: "14"
            },
            fontWeight: "100",
            _ios: {
              lineHeight: 5,
              fontSize: 12
            },
            _android: {
              lineHeight: 5,
              fontSize: 12
            }
          };
        },
        restaurantDetails_RestTimings_SpecialHoursText: function restaurantDetails_RestTimings_SpecialHoursText() {
          return {
            fontWeight: 300,
            fontSize: 12,
            color: "#606060",
            fontStyle: "italic"
          };
        },
        //Restaurant About
        restaurantDetails_RestAbout_TitleText: function restaurantDetails_RestAbout_TitleText() {
          return {
            fontFamily: "Bebas-New",
            color: "restaurantAboutSectionHeadingTextColor",
            marginBottom: 4,
            fontSize: "20px",
            lineHeight: 6,
            display: {
              base: "flex",
              lg: "none"
            }
          };
        },
        restaurantDetails_RestAbout_DescText: function restaurantDetails_RestAbout_DescText() {
          return {
            color: "restaurantAboutSectionBodyTextColor",
            paddingBottom: 4,
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            lineHeight: "5"
          };
        },
        //Restaurant Action Buttons
        restaurantDetails_ActionButtons_CTAButtonLabelText: function restaurantDetails_ActionButtons_CTAButtonLabelText() {
          return {
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            textAlign: "center",
            color: {
              base: "#A1784D",
              lg: "amenitiesActionButtonsColor"
            },
            _ios: {
              textTransform: "uppercase"
            },
            _android: {
              textTransform: "uppercase"
            }
          };
        },
        //Restaurant Amenities
        restaurantDetails_Amenities_TitleText: function restaurantDetails_Amenities_TitleText() {
          return {
            paddingBottom: 4,
            fontSize: {
              base: 18,
              lg: 24
            },
            color: "amenitiesHeadingColor",
            display: {
              base: "flex"
            },
            fontFamily: "Bebas-New"
          };
        },
        restaurantDetails_Amenities_IconName: {
          fontWeight: 300,
          fontSize: {
            base: "12",
            lg: "16"
          },
          color: "#606060"
        },
        restaurantDetails_Amenities_Description: {
          fontSize: {
            base: 12,
            lg: 14
          },
          fontWeight: "300",
          color: "#606060"
        },
        restaurantDetails_Amenities_Title: {
          fontSize: {
            base: 14,
            lg: 16
          },
          mb: 1
        },
        //Restaurant Holiday Msg
        restaurantDetails_HolidayMsg_Text: {
          textAlign: "center",
          fontSize: {
            base: "14px"
          },
          color: "white",
          fontWeight: "400",
          maxW: {
            base: "250px",
            md: "350",
            lg: "100%"
          },
          mx: "auto",
          lineHeight: 5
        },
        //Restaurant Order Button
        restaurantDetails_OrderButton_LabelText: function restaurantDetails_OrderButton_LabelText() {
          return {
            _android: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            _ios: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            fontSize: "16px",
            color: "orderFromHereButtonTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDay: function restaurantDetails_RestTimings_WeekDay() {
          return {
            color: "#2A2C25",
            fontSize: {
              base: "10",
              lg: "12"
            },
            position: "absolute"
          };
        },
        locationTitleHeader: function locationTitleHeader() {
          return {
            fontWeight: 400,
            fontSize: 20,
            color: "preferredLocationHeaderTextColor",
            textTransform: "uppercase"
          };
        },
        waitlist_leave_the_line_text: function waitlist_leave_the_line_text() {
          return {
            fontSize: 16,
            fontWeight: 300,
            color: "#606060"
          };
        },
        waitlist_leave_the_line_link: function waitlist_leave_the_line_link() {
          return {
            fontSize: 16,
            fontWeight: 400,
            color: "#A1784D"
          };
        },
        restDetails_TextMapper_Title: function restDetails_TextMapper_Title() {
          return {
            fontWeight: 400,
            fontSize: 28,
            mb: 4,
            color: "white",
            textAlign: "left"
          };
        },
        restDetails_TextMapper_Description: function restDetails_TextMapper_Description() {
          return {
            fontWeight: 300,
            fontSize: 18,
            color: "white",
            textAlign: "left"
          };
        },

        /* Restaurant Details End */
        reservationConfirmationText: {
          fontWeight: 300
        },
        //LocationSearch Start
        locationSearchHeading: function locationSearchHeading() {
          return {
            fontWeight: 500,
            fontSize: 24,
            fontFamily: "headingSecondary",
            color: "locationSearchTitle"
          };
        },
        recentLocationsText: function recentLocationsText() {
          return {
            fontSize: {
              base: 17,
              md: 20
            },
            fontWeight: 500,
            lineHeight: 5
          };
        },
        locationSearch_search_current_location_text: function locationSearch_search_current_location_text() {
          return {
            fontSize: {
              base: "md",
              md: "sm"
            },
            lineHeight: {
              base: 5,
              md: 4
            },
            color: "searchCurrentLocation"
          };
        },
        orderSettingsQuantityText: function orderSettingsQuantityText() {
          return {
            fontSize: "md",
            py: 2,
            px: 5
          };
        },
        sliderTitleText: function sliderTitleText() {
          return {
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: 500
            }
          };
        },
        reorderButtonText: function reorderButtonText() {
          return {
            fontWeight: 500
          };
        },
        desktopBreadcrumbVariant: function desktopBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0"
          };
        },
        desktopLastBreadcrumbVariant: function desktopLastBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0"
          };
        },
        numberOfCartItems: function numberOfCartItems() {
          return {
            fontWeight: 500
          };
        },
        restTimingsSplMsg: function restTimingsSplMsg() {
          return {
            fontWeight: 300
          };
        },
        currentlyUnavailableText: function currentlyUnavailableText() {
          return {
            color: "primary.100",
            fontWeight: {
              base: 500
            }
          };
        },
        menuCartHeaderTexLineHeightForApp: {
          lineHeight: 5
        },
        legalDisclaimerText: {
          lineHeight: 5
        },
        menuDetailDesciptionMobile: function menuDetailDesciptionMobile() {
          return {
            fontFamily: {
              base: "Karla-Light",
              md: "Karla-Regular"
            },
            color: "#020001",
            fontSize: 14
          };
        },
        nutritionalInfoBottomSheetAllergenInfo: function nutritionalInfoBottomSheetAllergenInfo() {
          return {
            fontWeight: "400",
            fontSize: "xs"
          };
        },
        nutritionalInfoBottomSheetQuestion: function nutritionalInfoBottomSheetQuestion() {
          return {
            fontWeight: "400",
            fontSize: "sm"
          };
        },
        reservationInfoValue: function reservationInfoValue() {
          return {
            fontWeight: 500,
            fontSize: 12,
            color: "#020001",
            lineHeight: 5
          };
        },
        reservationInfoKey: function reservationInfoKey() {
          return {
            fontWeight: 400,
            fontSize: 11,
            color: "#303030",
            lineHeight: 5
          };
        }
      }
    },
    Input: {
      baseStyle: {
        rounded: 0,
        fontFamily: "Karla-Regular"
      },
      variants: {
        menuSearchInputContainer: {
          borderRadius: 8
        },
        borderRadiusValue: function borderRadiusValue(_ref33) {
          var radiusValue = _ref33.radiusValue,
              topRadiusValue = _ref33.topRadiusValue,
              bottomRadiusValue = _ref33.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    HStack: {
      variants: {
        /* RESERVATION */
        reservationConfirmationDateTimeSizeHStack: {
          justifyContent: "flex-start",
          alignItems: "flex-start",
          mr: 1
        },
        reservationConfirmationDateTimeSizeContainer: {
          pt: 4,
          px: 3,
          justifyContent: "space-between"
        },
        reservationLookUpSuccessHStack: function reservationLookUpSuccessHStack(_ref34) {
          var isError = _ref34.isError;
          return {
            justifyContent: "center",
            space: 2,
            alignItems: "center",
            py: 2,
            my: 2,
            bg: isError ? "#DF450530" : "#F9F8F1",
            maxW: {
              md: "340px"
            },
            w: "100%",
            borderRadius: 4
          };
        },
        reservationLocationCardHStack: {
          my: 4,
          mx: 5,
          alignItems: "center",
          px: 4,
          py: 3,
          borderRadius: 8,
          shadow: 10,
          bg: "white"
        },
        reservationLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 6,
          borderColor: "#DEDEDE",
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          }
        },
        reservationProfileCardHStack: {
          my: 4,
          _ios: {
            paddingX: 4
          },
          _android: {
            paddingX: 4
          },
          borderRadius: 0,
          shadow: 10,
          bg: {
            base: "white",
            md: "transparent"
          }
        },
        reservationProfileCardLoggedInHStack: {
          alignItems: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            justifyContent: "space-between",
            w: "100%",
            px: 4
          },
          my: 3,
          bg: "white"
        },

        /* RESERVATION */
        //JWC START
        jwcFooterBlock: {
          py: 2,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        jwcLocationHeaderBlock: {
          py: 5,
          px: 6,
          borderRadius: 12,
          bg: "white",
          borderColor: "transparent",
          borderWidth: 1
        },
        //JWC END
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_Outer_HStack: function joinWaitlist_StaticMap_Outer_HStack() {
          return {
            alignItems: "center",
            backgroundColor: "white",
            width: {
              md: "100%"
            }
          };
        },
        joinWaitlist_StaticMap_Inner_HStack: function joinWaitlist_StaticMap_Inner_HStack() {
          return {
            py: 4,
            pr: 4,
            flex: {
              md: 1
            },
            alignItems: "top",
            w: "100%",
            _ios: {
              alignItems: "flex-start"
            },
            _android: {
              alignItems: "flex-start"
            }
          };
        },
        joinWaitlist_StickyCTAButtons_Container: function joinWaitlist_StickyCTAButtons_Container() {
          return {
            bg: "white",
            py: 3,
            px: 4,
            space: 4,
            justifyContent: {
              lg: "flex-end"
            },
            _ios: {
              shadow: 15
            },
            _web: {
              shadow: 15
            }
          };
        },
        joinWaitlist_Header_Container: function joinWaitlist_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#D6D6D6"
          };
        },
        // JOIN WAITLIST END
        header: {
          bg: "themeTextColor"
        },
        checkoutBtn: {
          alignItems: "center",
          justifyContent: "space-around",
          _web: {
            height: "60px"
          },
          py: 3,
          px: 5,
          rounded: 8
        },
        scheduledOrderForm: {
          alignItems: "center",
          width: "100%",
          rounded: 6,
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          borderColor: "themeTextFieldBoundary",
          pl: 3,
          mb: 4
        },
        listItemBox: {
          borderRadius: 10
        },
        menuDetailIsUnavailable: function menuDetailIsUnavailable(_ref35) {
          var isSelected = _ref35.isSelected;
          return {
            bg: "#E5E5E5",
            borderWidth: isSelected ? 0 : 1,
            borderColor: "themeSectionSeparator",
            borderRadius: isSelected ? 0 : 13,
            shadow: 5,
            overflow: "hidden"
          };
        },
        restaurantDetails_Waitlist_Party_HStack: {
          justifyContent: "center",
          alignItems: "center",
          mb: {
            base: 5
          }
        },
        restaurantDetails_Waitlist_Button_HStack: {
          justifyContent: "center"
        },
        //Restaurant Details
        restaurantDetails_Index_RestAbout_HStack: {
          mt: "10",
          space: {
            lg: "md",
            xl: "2xl"
          }
        },
        restaurantDetails_Amenities_AmenitiesIcons_HStack: {
          alignItems: "center"
        },
        restaurantDetails_CurrentStatus_Icon_HStack: {
          alignItems: "center",
          justifyContent: "center",
          _web: {
            justifyContent: {
              base: "center",
              lg: "normal"
            }
          }
        },
        restaurantDetails_RestInfo_AddToFavourites_HStack: {
          alignItems: "center",
          mb: "6"
        },
        restaurantDetails_RestInfo_StarIcon_HStack: {
          alignItems: "center"
        },
        restaurantDetails_RestTime_HStack: {
          alignItems: "center",
          mb: "4"
        },
        restaurantDetails_RestTime_HoursLegend_HStack: {
          mr: "0",
          ml: "auto",
          justifyContent: "center"
        },
        restaurantDetails_RestTimings_WeekDaysIcon_HStack: {
          mb: 9,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_SelectedDay_HStack: {
          mb: 4,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_List_HStack: {
          marginBottom: 3,
          justifyContent: "space-between"
        },
        //Order Tracking
        orderTrackingPayNowButtonHStack: {
          bgColor: "payNowButtonBg",
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "space-between"
        },
        orderTrackingCallHelpHStack: {
          py: 4,
          px: 5,
          _web: {
            minHeight: "68px",
            bottom: 0
          },
          bgColor: "background.100",
          borderTopColor: "borderColorCallSection",
          borderTopWidth: 1,
          alignItems: "center",
          justifyContent: "space-between",
          mt: "auto"
        },
        //Location Search
        locationSearchSearchThisArea: {
          position: "absolute",
          top: {
            base: 4,
            md: 8
          },
          left: 0,
          alignItems: "center",
          width: "100%"
        },
        borderRadiusValue: function borderRadiusValue(_ref36) {
          var radiusValue = _ref36.radiusValue,
              topRadiusValue = _ref36.topRadiusValue,
              bottomRadiusValue = _ref36.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        menuDetailArrowPosition: {
          mt: 1.5
        },
        menuDetailPropertyAccordionDescriptionTile: {
          mt: {
            base: 1.5,
            md: 1
          }
        }
      }
    },
    VStack: {
      variants: {
        jwcWaitTimeBlock: {
          px: 6,
          py: 1,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        // JOIN WAITLIST START
        joinWaitlist_Guests_Container: function joinWaitlist_Guests_Container() {
          return {
            py: {
              lg: 2,
              base: 4
            },
            mb: 5,
            mx: 5,
            borderRadius: 16,
            shadow: 10,
            bg: "white",
            space: 3
          };
        },
        joinWaitlist_EstTime_Container: function joinWaitlist_EstTime_Container() {
          return {
            px: 5,
            pt: 5,
            mb: 5,
            _ios: {
              pt: 2,
              mb: 0
            },
            _android: {
              pt: 2,
              mb: 0
            }
          };
        },
        joinWaitlist_EstTime_Unvailable_Text_Container: function joinWaitlist_EstTime_Unvailable_Text_Container() {
          return {
            alignItems: "center",
            mt: 0,
            mb: 0,
            _ios: {
              mt: 0.5,
              mb: 2
            },
            _android: {
              mt: 0.5,
              mb: 2
            }
          };
        },
        joinWaitlist_WaitTimeInfo_Container: function joinWaitlist_WaitTimeInfo_Container() {
          return {
            bg: "white",
            px: 5,
            py: 5,
            mb: 5,
            borderBottomWidth: 1,
            borderColor: "themeSectionSeparator",
            _ios: {
              py: 3
            },
            _android: {
              py: 3
            }
          };
        },
        joinWaitlist_EstimatedWaitTime_AvailableStatus_VStack: {
          p: 5,
          space: 1,
          mb: 5,
          _ios: {
            mb: 2
          },
          _android: {
            mb: 2
          }
        },
        // JOIN WAITLIST END
        addToCartContainer: {
          w: {
            base: "76px",
            md: "120px"
          }
        },
        indicatorsContainer: {
          flex: 1
        },
        //Restaurant Details
        restaurantDetails_Index_RestInfo_VStack: {
          space: "xs"
        },
        restaurantDetails_Index_RestAbout_VStack: {
          mx: {
            lg: "60px"
          }
        },
        restaurantDetails_Index_RestAbout_InnerVStack: {
          flex: {
            lg: 4,
            xl: 1
          },
          space: "2xs"
        },
        restaurantDetails_Index_BrandFooter_VStack: {
          overflowX: "hidden"
        },
        restaurantDetails_ActionButtons_VStack: {
          space: "md"
        },
        restaurantDetails_RestInfo_StarIcon_VStack: {
          space: 4,
          justifyContent: "center",
          flex: 1,
          direction: "column-reverse"
        },
        //order tracking
        orderTrackingRefreshButtonVStack: {
          borderColor: "refreshButtonColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2,
          px: 1,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        orderTrackingAutoRefreshVStack: {
          borderColor: "orderStatusSectionBorderColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2.5,
          px: 4,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        nutritionalInfoVStack: {
          mt: {
            base: 2,
            md: 3
          },
          mb: "2",
          alignItems: "flex-start",
          width: "100%",
          _web: {
            width: {
              base: "100%",
              md: "100%",
              lg: "966px"
            }
          }
        },
        vstackBorderBottomRadius: {
          borderBottomRadius: 8
        }
      }
    },
    Flex: {
      variants: {
        orderConfirmationflex: {
          _web: {
            flexDirection: {
              base: "column-reverse",
              lg: "row"
            }
          }
        }
      }
    },
    Image: {
      variants: {
        cartItemImage: {
          _web: {
            height: {
              base: "71px"
            },
            width: {
              base: "100px"
            }
          },
          rounded: "md",
          height: 70,
          width: 100
        },
        menu_item_card_vertical_image_border_radius: 8,
        //Restaurant Details
        restaurantDetails_RestInfo_Mob_Image: {
          h: "98px",
          w: "98px",
          borderRadius: 10,
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "210px"
            },
            w: {
              base: "97px",
              lg: "220px"
            }
          }
        },
        restaurantDetails_RestInfo_ImageLg: {
          h: "98px",
          w: "98px",
          borderRadius: 10,
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "89px"
            },
            w: {
              base: "97px",
              lg: "94px"
            }
          }
        },
        restaurantDetails_RestInfo_FavoriteIconLg: {
          height: "16px",
          width: "16px"
        },
        restaurantDetails_RestInfo_BrandIcon: {
          borderRadius: 10
        },
        restaurantDetails_RestInfo_BrandIconLg: {
          borderRadius: 10
        },
        //Edit Waitlist
        editWaitlist_LocationHeader_Icon: {
          _web: {
            width: 4,
            height: 5
          }
        },
        rd_spl_hours_legend: {
          width: "11px",
          height: "11px",
          mr: "1"
        },
        rd_spl_hours_icon: {
          width: "11px",
          height: "11px",
          top: 0,
          right: 0,
          position: "absolute"
        },
        //location search page
        location_search_exclamation_icon: {
          display: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref37) {
          var radiusValue = _ref37.radiusValue,
              topRadiusValue = _ref37.topRadiusValue,
              bottomRadiusValue = _ref37.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        favorite_pin_fill_brand_icon: function favorite_pin_fill_brand_icon(_ref38) {
          var active = _ref38.active;
          return {
            height: active ? 8 : 6,
            width: active ? 8 : 6,
            _web: {
              bottom: "2px"
            }
          };
        },
        //cart overlay
        cart_overlay_pickup_date_brand_icon: {
          _web: {
            height: 5,
            width: 5
          },
          height: 20,
          width: 20,
          mr: 0
        },
        cart_overlay_pickup_time_brand_icon: {
          height: 20,
          width: 20,
          _web: {
            height: 5,
            width: 5
          },
          mr: 0
        }
      }
    },
    Box: {
      variants: {
        /*RESERVATION*/
        reservationConfirmationDateTimeSizeBox: {
          alignItems: "flex-start",
          flex: 1
        },
        reservationConfirmationBoxBorderRadius: {
          borderRadius: 6
        },
        reservationConfirmationDetailsBox: {
          borderRadius: 6,
          my: {
            base: 6,
            md: 0
          },
          py: {
            base: 5,
            md: 6
          },
          borderTopWidth: 1,
          borderColor: "#0000001a"
        },
        reservationProfileInputBox: {
          pl: {
            base: 4,
            md: 5
          },
          pr: 9,
          bg: "white",
          _web: {
            pb: 9
          },
          borderRadius: 4
        },
        reservationProfileContactDetailsBox: {
          py: 3,
          flex: 1,
          my: 3
        },
        reviewReservationsContainerBox: {
          mt: 8,
          alignItems: "center",
          px: 4,
          _web: {
            bg: {
              base: "reservationBg",
              md: "myReservationsBoxBg"
            },
            maxW: {
              md: "680px"
            },
            py: 8,
            mt: {
              base: 8,
              md: 16
            },
            px: {
              base: 5,
              md: 24
            },
            mb: {
              base: 8,
              md: 16
            }
          }
        },
        reservationDropdownRadius: 6,
        reservationLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 6,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        reservationLocationDropdownBox: {
          bg: "#F8F7F6",
          py: 4,
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        reservationAvailableTimeSlotBtnBox: {
          _web: {
            width: 24,
            py: 2
          },
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          borderRadius: 0,
          _ios: {
            width: 24,
            height: 10
          },
          _android: {
            width: 24,
            height: 10
          }
        },
        reservationAvailableTimeSlotsBox: {
          borderWidth: 1,
          _ios: {
            py: 3
          },
          _android: {
            py: 3
          },
          _web: {
            py: 4,
            px: 3
          },
          w: "100%",
          mt: 4,
          borderRadius: 0,
          bg: "white"
        },
        reservationTabsBtn: function reservationTabsBtn(_ref39) {
          var isActive = _ref39.isActive;
          return {
            minW: {
              base: "167px",
              md: "191px"
            },
            px: 1,
            h: {
              base: "38px",
              md: "42px"
            },
            bg: isActive ? "reservationBg" : "primary.100",
            borderTopRadius: 6
          };
        },

        /*RESERVATION*/
        remoteCheckinContainer: {
          px: 6,
          py: 4,
          _web: {
            borderRadius: "12px"
          },
          borderWidth: 1,
          borderColor: "#F4F4F4",
          borderRadius: 3,
          width: {
            base: "100%",
            md: "335px"
          },
          shadow: 13,
          justifyContent: "space-around",
          alignItems: "center"
        },
        rd_spl_hours_icon: {
          width: 11,
          height: 11,
          top: 0,
          right: 0,
          position: "absolute"
        },
        rd_spl_hours_legend: {
          width: 11,
          height: 11,
          mr: 1
        },
        indicatorBanner: {
          fontFamily: "Karla-Medium"
        },
        onboardingScreenTextContainer: {
          top: "71%"
        },
        OrderInfoBannerCartIconBox: {
          pb: 0
        },
        jwcHowItWorksBox: {
          borderBottomWidth: 1,
          borderBottomColor: {
            base: "#A1784D",
            lg: "white"
          }
        },
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_Box: function joinWaitlist_StaticMap_Box() {
          return {
            position: "relative",
            overflow: "hidden",
            height: {
              base: 101,
              md: "100%"
            },
            w: {
              md: 230,
              lg: 170,
              xl: 230
            }
          };
        },
        joinWaitlist_StaticMap_Icon_Container: function joinWaitlist_StaticMap_Icon_Container() {
          return {
            pl: {
              lg: 5,
              base: 3
            },
            pr: {
              lg: 3,
              base: 2
            },
            mt: {
              lg: -1,
              base: -0.5
            }
          };
        },
        joinWaitlist_Form_Container: function joinWaitlist_Form_Container() {
          return {
            bg: "white",
            rounded: 12,
            p: 5,
            mx: 5,
            shadow: {
              base: 10,
              lg: "none"
            }
          };
        },
        joinWaitlist_Form_Filled_Container: function joinWaitlist_Form_Filled_Container() {
          return {
            bg: "white",
            rounded: 12,
            py: 5,
            px: 4,
            mx: 5,
            shadow: 10
          };
        },
        waitlistDetailsBrandImage: function waitlistDetailsBrandImage() {
          return {
            bottom: -24
          };
        },
        // JOIN WAITLIST END
        remoteCheckinWaitTimeParentBox: {
          bg: "#F9F8F1"
        },
        checkinSuccessNote: {
          bg: "#A1784D",
          px: {
            base: 5,
            md: 9
          },
          py: 6,
          borderRadius: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        locationDropdownRadius: 0,
        emptyCartModalRadius: 8,
        appMessagesSuccessDialogBorderRadius: 6,
        sectionHeaderBottomSpace: function sectionHeaderBottomSpace(_ref40) {
          var hasSub = _ref40.hasSub;
          return {
            mb: {
              base: hasSub && -1,
              md: hasSub && -4
            }
          };
        },
        configOptionBox: {
          borderRadius: 12
        },
        configOptionBoxWithMAPPWidth: {
          borderRadius: 12,
          _ios: {
            minWidth: 72
          },
          _android: {
            minWidth: 72
          }
        },
        sliderItemBox: {
          borderRadius: {
            base: 8
          }
        },
        searchItemCardContainer: function searchItemCardContainer() {
          return {
            width: "100%",
            pr: 4,
            borderBottomWidth: 1,
            borderColor: "#EAEAEA"
          };
        },
        searchModalMenuCategoryListBox: function searchModalMenuCategoryListBox(_ref41) {
          var isMobile = _ref41.isMobile;
          return {
            borderRadius: !isMobile ? 12 : 0
          };
        },
        brandLogoMobileDimensions: function brandLogoMobileDimensions() {
          return {
            _ios: {
              height: 12,
              width: 40
            },
            _android: {
              height: 12,
              width: 40
            },
            _web: {
              height: "50px",
              width: "166px"
            }
          };
        },
        menuDetailDesciption: function menuDetailDesciption() {
          return {
            fontFamily: {
              base: "Karla-Light",
              md: "Karla-Regular"
            },
            color: "#020001",
            _web: {
              fontSize: {
                base: "14px",
                md: "16px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            }
          };
        },
        menuCardBodyPrice: {
          bottom: 0
        },
        menuItemDesciption: function menuItemDesciption() {
          return {
            fontWeight: 300,
            fontSize: 14,
            fontFamily: "Karla-Regular",
            textDecoration: "none"
          };
        },
        temperatureSlider: function temperatureSlider() {
          return {
            bg: "#E9E9E9",
            _web: {
              height: {
                base: "393px",
                md: "413px"
              },
              pb: 10
            },
            height: 400,
            pb: 10
          };
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        tempDescriptionBox: function tempDescriptionBox(_ref42) {
          var isChild = _ref42.isChild;
          return {
            px: {
              base: 3,
              md: isChild ? 3 : 5
            },
            py: 5,
            borderLeftRadius: 10,
            borderRightRadius: {
              base: 0,
              md: isChild ? 0 : 10
            },
            bg: "white",
            shadow: 11,
            _web: {
              width: {
                base: "177px",
                md: isChild ? "177px" : "325px"
              }
            }
          };
        },
        selectLocationDropDownBox: {
          ml: {
            base: 0,
            md: 8
          },
          mt: {
            base: 3,
            md: 0
          },
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          borderRadius: 8,
          _web: {
            width: {
              base: "100%",
              md: "335px"
            }
          },
          borderColor: {
            base: "allLocationsSelectBorderColorMobile",
            md: "allLocationsSelectBorderColorDesktop"
          }
        },
        locationCard: {
          borderBottomWidth: 1,
          borderWidth: {
            base: 0,
            md: 1
          },
          borderColor: "allLocationsItemBoxBorderColor",
          borderRadius: {
            base: 0,
            md: 8
          },
          p: {
            base: 0,
            md: 1
          },
          mt: {
            base: 0,
            md: 4
          },
          mr: {
            base: 0,
            md: 8
          },
          _web: {
            minWidth: {
              base: "100%",
              md: "300px"
            }
          },
          width: "40%",
          bg: "#ffffff"
        },
        listCard: {
          borderRadius: 8,
          position: "relative",
          pt: {
            base: 3
          },
          pb: {
            base: "14px"
          },
          px: {
            base: 3
          },
          p: {
            lg: 5
          }
        },
        headerCaretIconMobile: function headerCaretIconMobile() {
          return {
            mb: 0.5
          };
        },
        //Restaurant Details start
        restaurantDetails_Waitlist_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          pb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_WaitlistAlready_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          mb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_Index_Map_Box: {
          flex: 1
        },
        restaurantDetails_Index_RestInfo_Box: {
          flex: 1,
          borderBottomColor: "#D6D6D6",
          borderBottomWidth: "1px"
        },
        restaurantDetails_Index_RestInfo_InnerBox: {
          px: 5
        },
        restaurantDetails_Index_CurrentStatus_Box: function restaurantDetails_Index_CurrentStatus_Box(_ref43) {
          var hideWaitlistSection = _ref43.hideWaitlistSection;
          return {
            px: 8,
            mb: hideWaitlistSection ? 0 : 10
          };
        },
        restaurantDetails_Index_WaitList_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_Divider_Box: {
          px: 6
        },
        restaurantDetails_Index_Amenities_Box: {
          pt: 4
        },
        restaurantDetails_Index_RestTime_Box: {
          flex: {
            lg: 5,
            xl: 1
          }
        },
        restaurantDetails_Index_RestTime_Mob_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_ActionButtons_Box: {
          flex: {
            lg: 3,
            xl: 1
          },
          pr: 2
        },
        restaurantDetails_Index_Mob_OrderButton_Box: function restaurantDetails_Index_Mob_OrderButton_Box(_ref44) {
          var isSticky = _ref44.isSticky;
          return {
            py: 4,
            px: isSticky ? 4 : 0
          };
        },
        restaurantDetails_Index_Mob_RestAbout_Box: {
          h: "auto"
        },
        restaurantDetails_ActionButtons_ViewMenu_Box: function restaurantDetails_ActionButtons_ViewMenu_Box(_ref45) {
          var isMobile = _ref45.isMobile,
              singleActionButton = _ref45.singleActionButton;
          return {
            px: 4,
            _web: {
              display: "grid"
            },
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            style: {
              "grid-template-columns": "1fr",
              "column-gap": "10px"
            }
          };
        },
        restaurantDetails_ActionButtons_ViewMenu_InnerBox: {
          _web: {
            mb: {
              base: 3,
              lg: 4
            }
          }
        },
        restaurantDetails_Amenities_IconBox: {
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row"
        },
        restaurantDetails_Amenities_Box: {
          px: {
            base: 4,
            lg: 6
          }
        },
        restaurantDetails_CurrentStatus_Icon_Box: {
          mr: 2
        },
        restaurantDetails_CurrentStatus_Mob_Divider_Box: {
          mt: 4,
          alignItems: "center"
        },
        restaurantDetails_HolidayMsg_Box: {
          px: {
            base: 2,
            lg: 3
          },
          py: 3,
          bg: "#80603D"
        },
        restaurantDetails_Map_Box: {
          height: "140px",
          position: "relative"
        },
        restaurantDetails_OrderButtonSection_Box: function restaurantDetails_OrderButtonSection_Box(_ref46) {
          var isInStack = _ref46.isInStack;
          return {
            px: isInStack ? 0 : 4,
            _web: {
              mb: isInStack ? {
                base: 3,
                lg: 4
              } : 0
            },
            alignItems: "center"
          };
        },
        restaurantDetails_RestAboutSection_Box: {
          px: "6",
          py: {
            base: "6",
            lg: "0"
          }
        },
        restaurantDetails_RestInfo_Outer_ImageBox: {
          position: "relative",
          bg: {
            base: "restaurantDetailsRestInfoBoxBackgroundColor",
            lg: "white"
          }
        },
        restaurantDetails_RestInfo_Mob_StarIcon_Box: {
          m: "auto"
        },
        restaurantDetails_RestInfo_Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo__Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo_PhoneNum_Box: {
          mb: {
            base: 4,
            lg: 0
          },
          flexDirection: "row",
          justifyContent: {
            base: "space-evenly",
            lg: "flex-start"
          },
          alignItems: {
            base: "center"
          }
        },
        restaurantDetails_RestInfo_PhoneNum_InnerBox: {
          alignItems: "center",
          flexDirection: "row"
        },
        restaurantDetails_RestTime_Box: {
          px: "4",
          py: {
            base: "4",
            lg: "0"
          }
        },
        restaurantDetails_RestTime_RestClosed_Box: {
          my: 5
        },
        restaurantDetails_RestInfo_ImageBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          position: "absolute",
          zIndex: 1,
          alignSelf: "center",
          borderRadius: 15,
          shadow: 11,
          _web: {
            alignSelf: {
              base: "center",
              lg: "left"
            }
          },
          top: {
            base: "-50px",
            lg: "-150px"
          },
          overflow: "hidden"
        },
        restaurantDetails_RestInfo_ImageLgBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          borderRadius: 15,
          shadow: 11,
          mr: 6,
          ml: 3
        },
        restaurantDetails_CurrentStatusAndWaitlist_Box: {
          py: "5",
          px: {
            base: "4",
            lg: "8"
          },
          backgroundColor: {
            base: "white",
            lg: "#F4F4F4"
          },
          borderRadius: "12"
        },
        restaurantDetails_CurrentStatus_Box: {
          pt: {
            base: "5",
            lg: "0"
          },
          px: {
            base: "4",
            lg: "0"
          },
          backgroundColor: "white"
        },
        restaurantDetails_RestTimings_Divider: {
          marginBottom: 4
        },
        restDetails_TextMapper_Container: {
          py: 16,
          px: {
            base: "60",
            lg: "116"
          },
          bg: "#ffffff"
        },
        //Restaurant Details end
        //Location search
        tabLocationsTopWidth: 0,
        // location search page
        locationSearchActiveTab: function locationSearchActiveTab(_ref47) {
          var isActive = _ref47.isActive;
          return {
            height: "4px",
            bg: isActive ? "locationSearchActiveTab" : "transparent",
            w: "100%",
            borderTopRadius: "8px"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref48) {
          var radiusValue = _ref48.radiusValue,
              topRadiusValue = _ref48.topRadiusValue,
              bottomRadiusValue = _ref48.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        homeScreenAlertHeadingWrapper: function homeScreenAlertHeadingWrapper(_ref49) {
          var isSmallScreen = _ref49.isSmallScreen;
          return {
            height: isSmallScreen ? 6 : 7,
            mr: 1
          };
        },
        menu_detail_divider: {
          mb: 5
        },
        boxBorderRadius: {
          _web: {
            borderRadius: 8
          },
          borderRadius: 12
        },
        desktopBreadcrumbCaret: function desktopBreadcrumbCaret() {
          return {
            height: 2.5,
            width: 1,
            ml: 2.5,
            mr: 3,
            mb: 1,
            alignItems: "center"
          };
        },
        countLabelContainer: function countLabelContainer(_ref50) {
          var isIOS = _ref50.isIOS;
          return {
            _text: {
              color: "white",
              fontSize: 12
            }
          };
        },
        categoryBox: {
          mb: {
            md: 8,
            base: 3
          }
        },
        mobileGiftCardBrandLogo: {
          height: 35,
          width: 28
        }
      }
    },
    View: {
      variants: {
        confirmationCardLayout: function confirmationCardLayout() {
          return {
            borderRadius: 12
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref51) {
          var radiusValue = _ref51.radiusValue,
              topRadiusValue = _ref51.topRadiusValue,
              bottomRadiusValue = _ref51.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    Alert: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref52) {
          var radiusValue = _ref52.radiusValue,
              topRadiusValue = _ref52.topRadiusValue,
              bottomRadiusValue = _ref52.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    Menu: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref53) {
          var radiusValue = _ref53.radiusValue,
              topRadiusValue = _ref53.topRadiusValue,
              bottomRadiusValue = _ref53.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    ActionsheetContent: {
      variants: {
        topRounded: {}
      }
    },
    PopoverContent: {
      variants: {
        popoverRadius: function popoverRadius(_ref54) {
          var radiusValue = _ref54.radiusValue;
          return {
            borderRadius: radiusValue
          };
        }
      }
    },
    Switch: {
      baseStyle: {
        thumbColor: "#FFFFFF",
        onTrackColor: "primary.100"
      }
    },
    Select: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref55) {
          var radiusValue = _ref55.radiusValue,
              topRadiusValue = _ref55.topRadiusValue,
              bottomRadiusValue = _ref55.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    }
  },
  fontConfig: {
    Karla: {
      100: {
        normal: "Karla-Light"
      },
      200: {
        normal: "Karla-Light"
      },
      300: {
        normal: "Karla-Regular"
      },
      400: {
        normal: "Karla-Medium"
      },
      500: {
        normal: "Karla-Bold"
      },
      600: {
        normal: "Karla-ExtraBold"
      }
    },
    Bebas: {
      100: {
        normal: "Bebas-New"
      },
      200: {
        normal: "Bebas-New"
      },
      300: {
        normal: "Bebas-New"
      },
      400: {
        normal: "Bebas-New"
      },
      500: {
        normal: "Bebas-New"
      },
      600: {
        normal: "Bebas-New"
      }
    },
    Avenier: {
      100: "AvenierBlack",
      200: "AvenierRoman"
    }
  },
  fonts: {
    heading: "Karla",
    body: "Karla",
    headingSecondary: "Bebas",
    youMightLikeText: "Karla-Bold",
    headerFont: "AvenierBlack",
    footerFont: "AvenierRoman"
  },
  config: {
    // Changing initialColorMode to 'dark'
    initialColorMode: "light"
  }
}; // extend the theme

export var theme = extendTheme(_objectSpread(_objectSpread({}, baseTheme), config));